<template>
    <div class="container">
        <div v-if="logoutSplash" class="logout-splash">
        <span>{{ logoutMessage }}</span>
        </div>
        <div class="profile-container mt-10" v-if="profile">
            <div class="profile-image">
                <div class="profile-picture">
                    <span v-if="escort_data.profilepic == null" class="select-profile">
                        <img
                        src="../assets/no_image.png"
                        class="large-profile-pic"
                        alt=""
                        width="140px"
                        height="140px"
                        style="border-radius: 50%; cursor: pointer;"
                        @click="escortHasStory ? openStoryViewer() : openStoryUpload()"
                        >
                        <p class="text-white mt-2" style="font-size: 10px; text-align: center;">
                        Tap to upload your profile story
                        </p>
                    </span>

                    <span v-else class="select-profile">
                        <img
                        :src="escort_data.profilepic"
                        class="large-profile-pic"
                        alt=""
                        width="140px"
                        height="140px"
                        style="border-radius: 50%; cursor: pointer;"
                        @click="escortHasStory ? openStoryViewer() : openStoryUpload()"
                        >
                        <p class="text-white mt-2" style="font-size: 10px; text-align: center;">
                        Tap photo to {{ escortHasStory ? 'view' : 'upload' }} story
                        </p>

                        <div class="d-flex likes-followers justify-content-center">
                        <h4 class="badge badge-info">{{ profileCount }} views</h4>&nbsp;
                        <h4 class="badge badge-primary">{{ countFollowers }} followers</h4>
                        </div>
                    </span>
                </div>

                <div class="profile-info">
                    <h3>{{ toSentenceCase(escort_data.username) }}, {{ escort_data.age }} 
                        <span v-if="escort_data.activation_paid == 1" class="verified-icon" title="Verified">
                            <i class="fa fa-check-circle text-success"></i>
                        </span>
                       &nbsp;&nbsp;
                        <span 
                        class="copy-wrapper"
                        @click="copyProfile(escort_data.profile_link)"
                        >
                        <i style="cursor:pointer" class="fa fa-copy"></i>
                        <span class="tooltip-text">Copy profile link</span>
                        </span>
                    </h3>
                    <p>
                        {{ toSentenceCase(escort_data.location) }} {{ toSentenceCase(escort_data.state) }} | {{ escort_data.gender }} | <i class="fa fa-phone"></i>
                        <span v-if="escort_data.activation_paid == 1">
                            {{ escort_data.phone_number }}
                        </span>
                        <span v-else>
                            {{maskPhoneNumber(escort_data.phone_number)}}
                        </span>
                    </p>
                  
                    <!-- Green switch for Escort -->
                    <div class="form-check form-switch mt-0" v-if="escort_data.account_type === 'escort'">
                        <input class="form-check-input bg-success border-success" type="checkbox" id="escortSwitch"
                            checked
                            @change="toggleAccountType">
                        <label class="form-check-label" for="escortSwitch" style="font-size: 12px; color: aliceblue;">
                            Switch to Premium Content
                        </label>
                    </div>

                    <!-- Blue switch for Content Creator -->
                    <div class="form-check form-switch mt-0" v-else-if="escort_data.account_type === 'content-creator'">
                        <input class="form-check-input bg-primary border-primary" type="checkbox" id="contentSwitch"
                            checked
                            @change="toggleAccountType">
                        <label class="form-check-label" for="contentSwitch" style="font-size: 12px; color: aliceblue;">
                            Switch to Escort Services
                        </label>
                    </div>
                    
                    <hr class="mobile-line">
                    <p>{{ toSentenceCase(escort_data.bio) }} </p>
                   
                    <div class="bio-buttons mt-2 flex-nowrap overflow-auto">
                        <span v-if="escort_data.account_type === 'escort'">
                            <a v-if="is_boost_status == 'none'" @click.prevent="alertBoost">
                        <button class="btn-tour" style="cursor: pointer; opacity: 1;">
                            <i class="fa fa-map-marked-alt"></i> 
                            On Tour
                        </button>  
                        </a>

                        <a v-else-if="is_boost_status === 'boosts'" href="#ontour">
                            <button class="btn-tour">
                                <i class="fa fa-map-marked-alt"></i> 
                                On Tour
                            </button>  
                        </a>
                        &nbsp;
                        </span>
                       
                        <button  v-if="escort_data.activation_paid == 0" class="btn-boost disabled" style="cursor: not-allowed; opacity: 0.5;">
                            <i class="fa fa-bolt"></i> Boost Profile
                        </button> 
                        <button v-else class="btn-boost" @click="boost_profile(escort_data.username)">
                            <i class="fa fa-bolt"></i> Boost Profile
                        </button> 
                        &nbsp;
                        <button class="btn-activate" @click="activate_account(escort_data.username)" v-if="escort_data.activation_paid == 0">
                            Activate Account &nbsp;
                        </button> 
                    </div>
                </div>
            </div>
            <div class="profile-edit-button">
                <button class="btn-bank" @click="addBanks(userid)">
                    <i class="fa fa-home"></i> My Bank
                </button> 
                <button class="btn-wallet" @click="myWallet(userid)">
                    <i class="fa fa-wallet"></i> Wallet
                </button> 
                <button class="btn-edit" @click="editProfile(userid)">
                    <i class="fa fa-edit"></i> Update
                </button>
            </div>
        </div>
        <div class="bio-tab">
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs profile-tabs mb-3 flex-nowrap overflow-auto" role="tablist" v-if="escort_data.account_type === 'escort'">
                    <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === tab.name }"
                        @click="activeTab = tab.name"
                        href="#"
                    >
                        {{ tab.label }}
                    </a>
                    </li>
                </ul>
                <ul class="nav nav-tabs profile-tabs mb-3 flex-nowrap overflow-auto" role="tablist" v-else-if="escort_data.account_type === 'content-creator'">
                    <li class="nav-item" v-for="(tab, index) in tabs2" :key="index">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === tab.name }"
                        @click="activeTab = tab.name"
                        href="#"
                    >
                        {{ tab.label }}
                    </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content profile-tab-content p-3 border rounded">
                    <div v-if="activeTab === 'gallery'" class="tab-panel-section gallery-section">
                        <h5><strong><i class="fas fa-image"></i> Gallery</strong></h5>
                        <div class="photo-container">
                            
                            <div class="image-upload-wrapper">
                                <div class="image-preview" @click="handleClick(escort_data.activation_paid)">
                                <!-- Show image preview -->
                                <div 
                                    v-if="previewImage && isImage" 
                                    :style="{ backgroundImage: `url(${previewImage})` }" 
                                    class="preview-box"
                                ></div>

                                <!-- Show video preview -->
                                <video 
                                    v-else-if="previewImage && isVideo" 
                                    :src="previewImage" 
                                    controls 
                                    class="preview-video"
                                ></video>

                                <!-- Show upload placeholder -->
                                <span v-else class="upload-placeholder">
                                    <i class="fa fa-camera"></i><br>Click to Upload
                                </span>
                                </div>

                            <input 
                            type="file"
                            ref="fileInput"
                            id="image_input"
                            class="file-hidden"
                            accept="image/png, image/jpeg, image/jpg, video/mp4, video/*"
                            @change="pickFile"
                            />

                            <textarea style="padding: 0.3rem;" name="photo_desc" id="photo_desc" class="photo_desc mt-2" placeholder="Enter brief description" v-model="photo_desc" cols="20" rows="2"></textarea>
                           
                            <!-- Popup Dialog -->
                            <div v-if="showPremiumPopup" class="popup-backdrop">
                                <div class="popup-content premium-popup-card">
                                  <div class="premium-popup-header">
                                    <div class="premium-popup-title-wrap">
                                      <span class="premium-popup-eyebrow">Premium upload</span>
                                      <h5 class="premium-popup-title">Set this post as premium?</h5>
                                      <p class="premium-popup-subtitle mb-0">
                                        Choose a token price before you publish. Premium uploads will be visible to paying users only.
                                      </p>
                                    </div>

                                    <button
                                      type="button"
                                      class="premium-popup-close"
                                      @click="showPremiumPopup = false"
                                      aria-label="Close"
                                    >
                                      <i class="fa fa-times"></i>
                                    </button>
                                  </div>

                                  <div class="premium-popup-body">
                                    <div class="premium-info-card">
                                      <i class="fa fa-lock"></i>
                                      <div>
                                        <p class="premium-info-label mb-1">Visibility</p>
                                        <p class="premium-info-value mb-0">Premium content for subscribers</p>
                                      </div>
                                    </div>

                                    <input type="hidden" name="photo_price" class="photo_desc mt-0" placeholder="Price" v-model="photo_price" >

                                    <label class="premium-field-label" for="photo_token">Token price</label>
                                    <div class="premium-input-wrap">
                                      <input
                                        id="photo_token"
                                        type="text"
                                        name="photo_token"
                                        class="premium-token-input"
                                        placeholder="How many tokens?"
                                        v-model="photo_token"
                                        @input="tokenConversion"
                                      >
                                      <span class="premium-token-badge">{{ photo_price }}</span>
                                    </div>

                                    <p class="premium-helper-text mb-0">
                                      The final price updates as you type. Make sure the amount matches the value of this upload.
                                    </p>
                                  </div>

                                  <div class="premium-popup-actions">
                                    <button type="button" class="btn premium-btn premium-btn--primary" @click="premiumUpload">
                                      <i class="fa fa-check"></i>
                                      <span>Publish premium</span>
                                    </button>
                                    <button type="button" class="btn premium-btn premium-btn--secondary" @click="freeUpload">
                                      <i class="fa fa-eye"></i>
                                      <span>Make it free</span>
                                    </button>
                                    <button type="button" class="btn premium-btn premium-btn--ghost" @click="showPremiumPopup = false">
                                      <i class="fa fa-times"></i>
                                      <span>Cancel</span>
                                    </button>
                                  </div>
                                </div>
                            </div>
                            <div v-if="btn_success" class="upload-actions">
                                <button class="btn btn-success" @click="showPremiumPopup = true" v-if="!loading">
                                    <i class="fa fa-upload"></i> Upload
                                </button>
                                <button class="btn btn-success" type="button" disabled v-else>
                                <i class="fas fa-spinner fa-spin"></i> Uploading...
                                </button>
                            </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="row">
                                    <p v-if="escort_info == ''">
                                    <strong><i class="fa fa-picture"></i> Gallery</strong>
                                    </p>
                                    <p>&nbsp;</p>

                                    <div
                                    class="col-6 col-sm-3 col-md-2 mb-3"
                                    v-for="(media, index) in escort_info.galleries"
                                    :key="index"
                                     @mouseenter="loadVideo"
                                     @mouseleave="unloadVideo"
                                    >
                                    <v-carousel
                                        :continuous="false"
                                        :show-arrows="true"
                                        hide-delimiter-background
                                        delimiter-icon="mdi-square"
                                        hide-delimiters
                                        height="100%"
                                        width="100%"
                                        style="border-radius: 10px;"
                                    >
                                        <v-carousel-item>
                                        <span>
                                            <!-- Detect image or video -->
                                            <template v-if="isImagePage(media.path)">
                                            <img
                                                :src="media.path"
                                                alt="Escort Gallery"
                                                class="img-fluid"
                                                style="cursor: pointer; border-radius: 10px;"
                                                @click="selectedImage = media.path; showImageDialog = true"
                                            />
                                            </template>

                                            <template v-else-if="isVideoPage(media.path)">
                                            <!-- Thumbnail -->
                                            <img
                                            v-if="!videoLoaded"
                                            :src="media.thumb_path"
                                            loading="lazy"
                                             class="img-fluid"
                                            />
                                            <video
                                                v-if="videoLoaded"
                                                :src="media.path"
                                                muted
                                                autoplay
                                                loop
                                                playsinline
                                                style="width: 100%; height: 190px; object-fit: cover; border-radius: 10px;"
                                            >
                                                Your browser does not support the video tag.
                                            </video>
                                            </template>

                                            <template v-else>
                                            <p class="text-muted">Unsupported file type</p>
                                            </template>
                                        </span>

                                        <span class="text-white" style="font-size: 12px;" v-if="media.dayruns_token == 0">
                                            {{ media.description }}
                                        </span>
                                        <span class="text-white" style="font-size: 12px;" v-else>
                                            {{ media.description }}  ({{ formatAmount(media.dayruns_token) }}{{ token_label }})<br />
                                        </span>

                                        <span
                                            :class="media.is_premium == 'paid' ? 'text-white badge badge-success' : 'text-white badge badge-danger'"
                                        >
                                            {{ media.is_premium == "paid" ? "Premium" : "Free" }}
                                        </span>

                                        <div class="mt-2 text-center">
                                            <button
                                            @click="remove(media.path)"
                                            class="btn btn-sm btn-outline-danger"
                                            style="font-size: 11px; color: #D33E74;"
                                            >
                                            <i class="fa fa-trash"></i>
                                            </button>
                                        </div>
                                        </v-carousel-item>
                                    </v-carousel>
                                    </div>
                                </div>
                            </div>

                            <!-- Upload Warning Modal -->
                            <div 
                            v-if="showUploadWarning" 
                            class="modal fade show d-block" 
                            tabindex="-1" 
                            style="background: rgba(0,0,0,0.6);"
                            @click.self="closeModal"
                            >
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content p-4 text-center" style="border-radius: 15px;">
                                <h5 class="mb-3 text-danger">
                                    <i class="fa fa-exclamation-triangle"></i> Important Notice
                                </h5>
                                <p class="mb-3">
                                    Please upload <strong>real and authentic photos or videos of yourself only.</strong><br>
                                    Using fake, copied, or misleading content is strictly prohibited.
                                </p>
                                <p class="text-danger fw-bold">
                                    Any user found uploading false or deceptive media will be 
                                    <u>permanently blocked</u> from the system.
                                </p>
                                <button 
                                    class="btn btn-primary mt-3 px-4" 
                                    @click="closeModal"
                                >
                                    I Understand
                                </button>
                                </div>
                            </div>
                            </div>

                        </div>
                    </div>

                    <div v-if="activeTab === 'videos'" class="tab-panel-section media-section">
                        <!-- Videos content -->
                        <h5><strong><i class="fa fa-video"></i> Videos</strong></h5>
                        <div class="video-container">
                            
                            <div class="video-upload-wrapper">

                            <!-- Show loader while preview is loading -->
                            <div v-if="previewLoading" class="loading-overlay">
                                <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: #D33E74;"></i>
                                <p style="color: #D33E74">Loading preview...</p>
                            </div>
                            
                            <!-- Video Preview Box -->
                            <div
                                class="video-preview"
                                @click="$refs.videoInput.click()"
                                :style="previewVideo ? { backgroundColor: '#000' } : {}"
                            >
                                <!-- Video Preview -->
                                <video
                                v-if="previewVideo"
                                :src="previewVideo"
                                autoplay
                                loop
                                muted
                                playsinline
                                style="width: 100%; height: 100%; object-fit: cover;"
                                ></video>

                                <!-- Placeholder if no preview -->
                                <span v-else class="video-placeholder">
                                <i class="fa fa-video"></i><br />
                                Click to Upload Video
                                </span>
                            </div>

                            <!-- Hidden File Input -->
                            <input
                                type="file"
                                ref="videoInput"
                                class="video-hidden"
                                accept="video/mp4,video/webm,video/ogg"
                                @change="pickVideoFile"
                                v-if="escort_data.activation_paid == 1"
                            />
                            <input type="text" name="video_description" id="photo_desc" class="photo_desc mt-2" placeholder="Enter brief description" v-model="video_description">
                            <label style="font-size: 12px;">
                               Do you want to upload this video as premium?  <input type="checkbox" name="" id="" v-model="is_video_premium"> 
                            </label>
                            <div v-if="is_video_premium">
                                <input type="text" name="video_price" class="photo_desc mt-0" placeholder="Your video price?" v-model="video_price">
                            </div>
                            <!-- Upload Button -->
                            <div v-if="previewVideo" class="video-actions mt-2 text-center">
                                <button class="btn btn-success" @click="uploadVideo" v-if="!vloading">
                                <i class="fa fa-upload"></i> Upload
                                </button>
                                <button class="btn btn-success" type="button" disabled v-else>
                                <i class="fas fa-spinner fa-spin"></i> Uploading...
                                </button>
                            </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="row">
                                   
                                    <p>&nbsp;</p>
                                    <div
                                    class="col-6 col-sm-3 col-md-2 mb-3"
                                    v-for="(vid, index) in escort_video.videos" :key="index">
                                    <div style="position: relative; border-radius: 10px; overflow: hidden; cursor: pointer;">
                                        <!-- Video Element -->
                                        <video
                                        :src="vid.file"
                                        controls
                                        style="width: 100%; height: 200px; object-fit: cover; border-radius: 10px;"
                                        >
                                        Your browser does not support the video tag.
                                        </video>

                                        <!-- Optional: Play Icon Overlay if you want it only on hover -->
                                        <!--
                                        <div class="play-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;
                                            display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.3);">
                                        <i class="fa fa-play-circle" style="font-size: 40px; color: white;"></i>
                                        </div>
                                        -->

                                        
                                        <small>{{ vid.description }}({{ vid.dayruns_token }}DT)</small><br/>
                                        <span 
                                            :class="vid.is_premium == 'paid' ? 'text-white badge badge-success' : 'text-white badge badge-danger'">
                                            {{ vid.is_premium == "paid" ? "Premium" : "Free" }}
                                        </span>
                                        <div class="mt-2 text-center">
                                         <!-- Remove Button -->   
                                        <button
                                            class="btn btn-sm btn-outline-danger"
                                            @click="removeVideo(video)"
                                            title="Remove video"
                                        >
                                            <i class="fa fa-trash"></i>
                                        </button>
                                        </div>
                                    </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="activeTab === 'booking'" class="tab-panel-section booking-section">
                        <div class="card shadow-sm border-0 content-card">
                            <div class="card-header truthdare-header">
                                <div>
                                    <p class="section-kicker mb-1">Client requests</p>
                                    <h5 class="mb-0">Booking</h5>
                                </div>
                            </div>
                            <div class="card-body p-0 truthdare-shell">
                                <div class="table-responsive">
                                    <table class="table table-hover align-middle mb-0 truthdare-table booking-table" style="font-size: 12px;">
                                        <thead>
                                        <tr>
                                            <th>Client</th>
                                            <th>Token</th>
                                            <th>Contact</th>
                                            <th>DateTime</th>
                                            <th>Time</th>
                                            <th>Duration</th>
                                            <th>Message</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in bookingList" :key="index">
                                                <td>{{ item.fullname }}</td>
                                                <td>
                                                    {{ formatAmount(item.dayruns_token) }}{{ token_label }} <br>
                                                    <span v-if="item.status === 'accepted'" style="font-size: 12px;" class="text-primary">
                                                        (Fee held in escrow)
                                                    </span>
                                                    <span v-else-if="item.status === 'completed'" style="font-size: 12px;" class="text-success">
                                                        (Fee transfered to wallet)
                                                    </span>
                                                </td>
                                                <td>{{ item.phone }}</td>
                                                <td>{{ new Date(item.booked_at).toDateString() }}</td>
                                                <td>{{ item.time }}</td>
                                                <td>{{ item.duration }}</td>
                                                <td>{{ item.message }}</td>
                                                <td>
                                                <span v-if="item.status == 'interest'">
                                                    {{ item.fullname }} is interested in booking you. Please respond to the request.
                                                </span>
                                                <span v-else
                                                    class="truthdare-status"
                                                    :class="{
                                                    'badge-success': item.status === 'accepted' || item.status === 'completed',
                                                    'badge-primary': item.status === 'declined',
                                                    'badge-danger': item.status === 'cancelled' || item.status === 'expired',
                                                    'badge-warning': item.status === 'pending',
                                                    }"
                                                >
                                                
                                                    {{ item.status }}
                                                </span>
                                                </td>
                                                <td>
                                                    <button style="background: #D33E74;" v-if="item.status === 'pending'" class="btn btn-outline-light btn-sm" @click="openActionModal(item.id)"><i class="fa fa-edit"></i></button>
                                                    <button style="background: #D33E74;" v-else-if="item.status === 'accepted'" class="btn btn-outline-light btn-sm" @click="openTransactionModal(item.id)">view fee</button>
                                                    <button
                                                        v-if="item.status === 'accepted' && item.fees_status === 'pending'"
                                                        class="btn btn-danger btn-sm ms-1"
                                                        @click="openBookingDisputeModal(item)"
                                                    >
                                                        <i class="fa fa-exclamation-triangle"></i> Dispute
                                                    </button>
                                                </td>
                                            
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- Action Modal -->
                            <div class="modal fade" id="actionModal" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                    
                                    <div class="modal-header">
                                        <h5 class="modal-title">Booking Action</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                    </div>

                                    <div class="modal-body">
                                        <p style="font-size: 12px">Do you want to <b>accept</b> or <b>decline</b> this booking?</p>
                                    </div>

                                    <div class="modal-footer">
                                        <button class="btn btn-success" @click="action_data(selectedBooking, 'accepted')" data-bs-dismiss="modal">
                                        Accept
                                        </button>
                                        <button class="btn btn-danger" @click="action_data(selectedBooking, 'declined')" data-bs-dismiss="modal">
                                        Decline
                                        </button>
                                    </div>

                                    </div>
                                </div>
                            </div>

                             <!-- Transactions Modal -->
                            <div class="modal fade" id="transactionModal" tabindex="-1" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                    
                                    <div class="modal-header truthdare-header">
                                        <div>
                                            <p class="section-kicker mb-1">Payment trail</p>
                                            <h5 class="modal-title mb-0">Transactions</h5>
                                        </div>
                                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                    </div>

                                    <div class="modal-body truthdare-shell">

                                        <table class="table table-striped table-hover align-middle mb-0 truthdare-table" style="font-size: 12px">
                                        <thead>
                                        <tr>
                                            <th>Token</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(item, index) in transactionList" :key="index">
                                          
                                            <td>
                                                {{ formatAmount(item.dayruns_token) }}{{ token_label }} <br>
                                            </td>
                                            <td>
                                            <span
                                                class="badge"
                                                :class="{
                                                'badge-success': item.status === 'approved',
                                                'badge-warning': item.status === 'pending'
                                                }"
                                            >
                                                {{ item.status }}
                                            </span>
                                            </td>
                                            <td>
                                                <button v-if="item.status === 'approved'" class="truthdare-action-btn btn btn-success btn-sm" @click="widthdrawFee(item.dayruns_token, item.truthdare_id)" >Transfer to Wallet <i class="fa fa-arrow-right"></i></button>
                                            </td>
                                        
                                        </tr>
                                        </tbody>
                                    </table>
                                       
                                    </div>

                                    </div>
                                </div>
                            </div>

                            <!-- Booking Dispute Modal -->
                            <div class="modal fade" id="bookingDisputeModal" tabindex="-1" aria-hidden="true" ref="bookingDisputeModal">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header bg-danger text-white">
                                            <h5 class="modal-title">
                                                <i class="fa fa-exclamation-triangle me-2"></i> Report No Release
                                            </h5>
                                            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                        </div>
                                        <div class="modal-body">
                                            <p class="text-muted mb-2">
                                                Use this if the client received the service but refused to release payment.
                                            </p>

                                            <div class="mb-3">
                                                <label class="form-label fw-semibold">Client</label>
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    :value="selectedBookingDispute.fullname || selectedBookingDispute.client_name || selectedBookingDispute.name || 'N/A'"
                                                    readonly
                                                >
                                            </div>

                                            <div class="mb-3">
                                                <label class="form-label fw-semibold">Reason</label>
                                                <textarea
                                                    class="form-control"
                                                    rows="4"
                                                    v-model="bookingDisputeReason"
                                                    placeholder="Tell us what happened"
                                                ></textarea>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                            <button class="btn btn-danger" @click="submitBookingDispute">Submit Dispute</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div v-if="activeTab === 'rate'" class="tab-panel-section rate-section">
                    <!-- Rates content -->
                    <h5><strong><i class="fas fa-receipt"></i> Booking Rates</strong></h5>
                    <div class="rates">
                        <!-- <span class="label-title"></span> -->
                        <div class="rate-row" v-for="(rate, index) in rates" :key="index">
                            <div class="rate-inputs">
                            <input type="text" v-model="rate.duration" placeholder="e.g. 1 Hour" class="input-textx" />
                            <input type="hidden" v-model="rate.in_call_price" placeholder="In Call Rate" class="input-textx" />
                            <input type="text" v-model="rate.in_call_dayruns_token" placeholder="In Call Rate" class="input-textx"/>
                            <input type="hidden" v-model="rate.out_call_price" placeholder="Out Call Rate" class="input-textx" />
                            <input type="text" v-model="rate.out_call_dayruns_token" placeholder="Out Call Rate" class="input-textx"/>
                            </div>
                            <button class="btn-remove" @click="removeRate(index)"><i class="fa fa-trash"></i></button>
                        </div>

                        <button class="btn-add label-title" @click="addRate"><i class="fa fa-plus"></i> Add</button>

                        <button class="btn-user-login" @click="saveRates" v-if="!loading">Save</button>
                        <button class="btn-user-login" type="button" disabled v-if="loading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Saving...
                        </button>
                    </div>

                    </div>

                    <div v-if="activeTab === 'preferences'" class="tab-panel-section preferences-section">
                    <!-- Preferences content -->
                    <h5><strong><i class="fas fa-bullseye"></i>  Preferences and Services</strong></h5>
                    <hr>
                    <div class="preferences">
                        <span class="label-title">Transport</span>
                        <div class="checkbox-group">
                        <label>
                            <input type="radio" value="I want my fare covered" v-model="transportPreference" />
                            I want my fare covered
                        </label>
                        <label>
                            <input type="radio" value="I can cover my fare" v-model="transportPreference" />
                            I can cover my fare
                        </label>
                        <label>
                            <input type="radio" value="Split fare is fine" v-model="transportPreference" />
                            Split fare is fine
                        </label>
                        <label>
                            <input type="radio" value="Provide driver or transport" v-model="transportPreference" />
                            Provide driver or transport
                        </label>
                        <label>
                            <input type="radio" value="Transport not required" v-model="transportPreference" />
                            Transport not required
                        </label>
                        </div>

                        <span class="label-title">Personality</span>
                        <div class="checkbox-group">
                            <label><input type="checkbox" value="Friendly" v-model="personality"> Friendly</label>
                            <label><input type="checkbox" value="Reserved" v-model="personality"> Reserved</label>
                            <label><input type="checkbox" value="Wild" v-model="personality"> Wild</label>
                        </div>

                        <span class="label-title">Gender Type</span>
                        <div class="checkbox-group">
                        <label>
                            <input type="radio" value="Straight" v-model="genderType"> Straight
                        </label>
                        <label>
                            <input type="radio" value="Lesbian" v-model="genderType"> Lesbian
                        </label>
                        <label>
                            <input type="radio" value="Gay" v-model="genderType"> Gay
                        </label>
                        <label>
                            <input type="radio" value="Bisexual" v-model="genderType"> Bisexual
                        </label>
                        <label>
                            <input type="radio" value="Transgender" v-model="genderType"> Transgender
                        </label>
                        <label>
                            <input type="radio" value="Other" v-model="genderType"> Other
                        </label>
                        </div>

                        <span class="label-title">Likes & Interests</span>
                        <div class="checkbox-group">
                            <label><input type="checkbox" value="Music" v-model="interests"> Music</label>
                            <label><input type="checkbox" value="Fashion" v-model="interests"> Fashion</label>
                            <label><input type="checkbox" value="Travel" v-model="interests"> Travel</label>
                            <label><input type="checkbox" value="Movies" v-model="interests"> Movies</label>
                        </div>

                        <span class="label-title">Turn Ons</span>
                        <div class="checkbox-group">
                            <label><input type="checkbox" value="Sensual touch" v-model="turnOns"> Sensual touch</label>
                            <label><input type="checkbox" value="Good hygiene" v-model="turnOns"> Good hygiene</label>
                            <label><input type="checkbox" value="Confidence" v-model="turnOns"> Confidence</label>
                        </div>

                        <span class="label-title">Turn Offs</span>
                        <div class="checkbox-group">
                            <label><input type="checkbox" value="Rudeness" v-model="turnOffs"> Rudeness</label>
                            <label><input type="checkbox" value="Bad hygiene" v-model="turnOffs"> Bad hygiene</label>
                            <label><input type="checkbox" value="Disrespect" v-model="turnOffs"> Disrespect</label>
                        </div>

                        <span class="label-title">Do you Smoke?</span>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Yes" v-model="smokes"> Yes</label>
                            <label><input type="radio" value="No" v-model="smokes"> No</label>
                        </div>

                        <span class="label-title">Do you Drink?</span>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Yes" v-model="drinks"> Yes</label>
                            <label><input type="radio" value="No" v-model="drinks"> No</label>
                        </div>

                        <span class="label-title">Tattoos or Piercings?</span>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Tattoos" v-model="tattoosOrPiercings"> Tattoos</label>
                            <label><input type="radio" value="Piercings" v-model="tattoosOrPiercings"> Piercings</label>
                            <label><input type="radio" value="Both" v-model="tattoosOrPiercings"> Both</label>
                            <label><input type="radio" value="None" v-model="tattoosOrPiercings"> None</label>
                        </div>

                        <span class="label-title">Accept Group Bookings?</span>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Yes" v-model="groupBooking"> Yes</label>
                            <label><input type="radio" value="No" v-model="groupBooking"> No</label>
                        </div>

                        <span class="label-title">Open to Video Chat?</span>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Yes" v-model="videoChatAvailable"> Yes</label>
                            <label><input type="radio" value="No" v-model="videoChatAvailable"> No</label>
                        </div>

                        <!-- Build -->
                        <div class="form-group">
                        <label class="label-title">Build</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Slim" v-model="build"> Slim</label>
                            <label><input type="radio" value="Athletic" v-model="build"> Athletic</label>
                            <label><input type="radio" value="Curvy" v-model="build"> Curvy</label>
                            <label><input type="radio" value="Average" v-model="build"> Average</label>
                            <label><input type="radio" value="BBW" v-model="build"> BBW</label>
                        </div>
                        </div>

                        <!-- Bust Size -->
                        <div class="form-group">
                        <label class="label-title">Bust Size</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="A" v-model="bustSize"> A</label>
                            <label><input type="radio" value="B" v-model="bustSize"> B</label>
                            <label><input type="radio" value="C" v-model="bustSize"> C</label>
                            <label><input type="radio" value="D" v-model="bustSize"> D</label>
                            <label><input type="radio" value="DD" v-model="bustSize"> DD</label>
                            <label><input type="radio" value="E+" v-model="bustSize"> E+</label>
                        </div>
                        </div>

                        <!-- Ethnicity -->
                        <div class="form-group">
                        <label class="label-title">Ethnicity</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Black" v-model="ethnicity"> Black</label>
                            <label><input type="radio" value="White" v-model="ethnicity"> White</label>
                            <label><input type="radio" value="Asian" v-model="ethnicity"> Asian</label>
                            <label><input type="radio" value="Latina" v-model="ethnicity"> Latina</label>
                            <label><input type="radio" value="Mixed" v-model="ethnicity"> Mixed</label>
                            <label><input type="radio" value="Arab" v-model="ethnicity"> Arab</label>
                            <label><input type="radio" value="Other" v-model="ethnicity"> Other</label>
                        </div>
                        </div>

                        <!-- Education -->
                        <div class="form-group">
                        <label class="label-title">Education</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="High School" v-model="education"> High School</label>
                            <label><input type="radio" value="Diploma" v-model="education"> Diploma</label>
                            <label><input type="radio" value="Undergraduate" v-model="education"> Undergraduate</label>
                            <label><input type="radio" value="Graduate" v-model="education"> Graduate</label>
                            <label><input type="radio" value="Postgraduate" v-model="education"> Postgraduate</label>
                        </div>
                        </div>

                        <!-- Occupation -->
                        <div class="form-group">
                        <label class="label-title">Occupation</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Student" v-model="occupations"> Student</label>
                            <label><input type="radio" value="Model" v-model="occupations"> Model</label>
                            <label><input type="radio" value="Entrepreneur" v-model="occupations"> Entrepreneur</label>
                            <label><input type="radio" value="Self-Employed" v-model="occupations"> Self-Employed</label>
                            <label><input type="radio" value="Other" v-model="occupations"> Other</label>
                        </div>
                        </div>

                        <!-- Weight -->
                        <div class="form-group">
                        <label class="label-title">Weight</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Below 50kg" v-model="weight"> Below 50kg</label>
                            <label><input type="radio" value="50-60kg" v-model="weight"> 50–60kg</label>
                            <label><input type="radio" value="61-70kg" v-model="weight"> 61–70kg</label>
                            <label><input type="radio" value="71-80kg" v-model="weight"> 71–80kg</label>
                            <label><input type="radio" value="81-90kg" v-model="weight"> 81–90kg</label>
                            <label><input type="radio" value="Above 90kg" v-model="weight"> Above 90kg</label>
                        </div>
                        </div>

                        <!-- Height -->
                        <div class="form-group">
                        <label class="label-title">Height</label>
                        <div class="checkbox-group">
                            <label><input type="radio" value="Below 5'" v-model="height"> Below 5'</label>
                            <label><input type="radio" value="5'0 - 5'4" v-model="height"> 5'0 - 5'4</label>
                            <label><input type="radio" value="5'5 - 5'9" v-model="height"> 5'5 - 5'9</label>
                            <label><input type="radio" value="5'10 - 6'0" v-model="height"> 5'10 - 6'0</label>
                            <label><input type="radio" value="Above 6'" v-model="height"> Above 6'</label>
                        </div>
                        </div>
                        <div class="form-group">
                        <label class="label-title">Services</label>
                        <div class="checkbox-group">
                            <label><input type="checkbox" value="Anal Rimming (Licking anus)" v-model="services"> Anal Rimming (Licking anus)</label>
                            <label><input type="checkbox" value="Erotic massage" v-model="services"> Erotic massage</label>
                            <label><input type="checkbox" value="Smoking (Fetish)" v-model="services"> Smoking (Fetish)</label>
                            <label><input type="checkbox" value="BDSM (giving)" v-model="services"> BDSM (giving)</label>
                            <label><input type="checkbox" value="Couples" v-model="services"> Couples</label>
                            <label><input type="checkbox" value="Dinner Dates" v-model="services"> Dinner Dates</label>
                            <label><input type="checkbox" value="GFE (Girlfriend experience)" v-model="services"> GFE (Girlfriend experience)</label>
                            <label><input type="checkbox" value="Hand Job" v-model="services"> Hand Job</label>
                            <label><input type="checkbox" value="Attending corporate parties" v-model="services"> Attending corporate parties</label>
                            <label><input type="checkbox" value="COB (Cum on body)" v-model="services"> COB (Cum on body)</label>
                            <label><input type="checkbox" value="MMF 3somes" v-model="services"> MMF 3somes</label>
                            <label><input type="checkbox" value="O-Level (Oral sex)" v-model="services"> O-Level (Oral sex)</label>
                            <label><input type="checkbox" value="Prostrate Massage" v-model="services"> Prostrate Massage</label>
                            <label><input type="checkbox" value="Receiving Oral" v-model="services"> Receiving Oral</label>
                            <label><input type="checkbox" value="Sex toys" v-model="services"> Sex toys</label>
                            <label><input type="checkbox" value="Erotic Spanking (giving)" v-model="services"> Erotic Spanking (giving)</label>
                            <label><input type="checkbox" value="Pegging" v-model="services"> Pegging</label>
                            <label><input type="checkbox" value="Tantric Massage" v-model="services"> Tantric Massage</label>
                            <label><input type="checkbox" value="Travel Companion" v-model="services"> Travel Companion</label>
                            <label><input type="checkbox" value="Rimming (giving)" v-model="services"> Rimming (giving)</label>
                            <label><input type="checkbox" value="Blow Job" v-model="services"> Blow Job</label>
                            <label><input type="checkbox" value="69 (69 sex position)" v-model="services"> 69 (69 sex position)</label>
                            <label><input type="checkbox" value="DFK (Deep french kissing)" v-model="services"> DFK (Deep french kissing)</label>
                            <label><input type="checkbox" value="Foot Fetish" v-model="services"> Foot Fetish</label>
                            <label><input type="checkbox" value="Lap dancing" v-model="services"> Lap dancing</label>
                            <label><input type="checkbox" value="Massage" v-model="services"> Massage</label>
                            <label><input type="checkbox" value="French Kissing" v-model="services"> French Kissing</label>
                            <label><input type="checkbox" value="Threesome" v-model="services"> Threesome</label>
                        </div>
                        </div>

                        <button class="btn-user-login" @click="create_preferences()" v-if="!cloading"> Create </button>
                        <button class="btn-user-login" type="button" disabled v-if="cloading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Creating...
                        </button>

                    </div>

                    </div>

                    <div v-if="activeTab === 'review'" class="tab-panel-section profile-review-section">
                    <!-- Review content -->
                    <h5><strong><i class="fa fa-star"></i> Reviews</strong></h5>
                          <!-- Review List -->
                      <div class="row g-3">
                        <div 
                          class="col-12 col-md-6" 
                          v-for="(item, index) in reviews" 
                          :key="index"
                        >
                          <div class="card shadow-sm h-100 profile-review-card">
                            <div class="card-body">
                              <div class="d-flex justify-content-between align-items-center mb-2">
                                <h6 class="card-title mb-0">{{ item.reviewer }}</h6>
                                <small class="text-muted">{{ new Date(item.created_at).toLocaleDateString('en-US', { year:'numeric', month:'short', day:'numeric' }) }}</small>
                              </div>

                              <!-- Stars -->
                              <div class="mb-2">
                                <span v-for="n in 5" :key="n">
                                  <i class="fa" :class="n <= item.rating ? 'fa-star text-warning' : 'fa-star-o text-secondary'"></i>
                                </span>
                              </div>

                              <!-- Review Text -->
                              <p class="card-text" style="white-space: pre-wrap;">{{ item.review }}</p>
                            </div>
                          </div>
                        </div>

                        <!-- No Reviews -->
                        <div v-if="reviews.length === 0" class="col-12">
                          <p class="text-center text-white" style="font-size: 12px;">No reviews yet.</p>
                        </div>
                      </div>
                    </div>

                    <div v-if="activeTab === 'follows'" class="tab-panel-section follows-section">
                        <!-- Follows content -->
                        <h5><strong><i class="fa fa-users"></i> Followers</strong></h5>
                        <div class="followers-section mt-3">


                        <div v-if="listFollowers.length > 0" class="list-group">
                            <div
                            v-for="(data, index) in listFollowers"
                            :key="index"
                            class="list-group-item d-flex justify-content-between align-items-center"
                            style="border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); margin-bottom: 10px;"
                            >
                            <div>
                                <strong style="color: #D33E74;">{{ data.username }}</strong><br>
                                <small class="text-muted">Joined: {{ new Date(data.created_at).toLocaleDateString() }}</small>
                            </div>
                            <div>
                                <i class="fa fa-user" style="color: #999;"></i>
                            </div>
                            </div>
                        </div>

                        <div v-else>
                            <p class="text-muted">No followers yet.</p>
                        </div>
                        </div>

                    </div>

                    <div v-if="activeTab === 'subscriptions'" class="tab-panel-section subscriptions-section">
                        <template>
                        <div>
                            <!-- Header with Create Button -->
                            <div class="card shadow-sm border-0 content-card">
                                <div class="card-header truthdare-header">
                                    <div>
                                        <p class="section-kicker mb-1">Account records</p>
                                        <h5 class="mb-0">Subscriptions</h5>
                                    </div>
                                    <button class="btn btn-primary btn-sm truthdare-action-btn" @click="showModal = true">
                                        <i class="fa fa-plus-circle"></i> Add
                                    </button>
                                </div>

                                <div class="card-body p-0 truthdare-shell">
                                    <!-- Subscription Table -->
                                    <div class="table-responsive">
                                        <table class="table table-bordered table-striped truthdare-table" style="font-size: 12px">
                                        <thead>
                                            <tr>
                                            <th>Package Name</th>
                                            <th>Token</th>
                                            <th>Duration (Days)</th>
                                            <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="sub in subscriptions" :key="sub.id">
                                            
                                            <td>{{ sub.category }}</td>
                                           
                                            <td>{{ sub.dayruns_token }}{{ token_label }}</td>
                                            <td>{{ sub.duration }}</td>
                                            <td>
                                                <button class="btn btn-sm btn-success text-sm truthdare-action-btn" @click="openEditModal(sub)">
                                                    <i class="fa fa-edit"></i>Edit
                                                </button>

                                                <button class="btn btn-sm btn-danger truthdare-action-btn" @click="deleteSubscription(sub.id)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </td>
                                            </tr>
                                            <tr v-if="subscriptions.length === 0">
                                            <td colspan="6" class="text-center text-muted py-4">No subscriptions yet</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- Create Subscription Modal -->
                            <div v-if="showModal" class="modal fade show d-block" tabindex="-1">
                            <div class="modal-dialog modal-lg">
                                <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Create Subscription</h5>
                                    <button type="button" class="btn-close" @click="cancel()"></button>
                                </div>
                                <div class="modal-body">
                                    
                                    <div class="mb-3">
                                        <label class="form-label">Package Name</label>
                                        <select v-model="form.tier_name" class="form-select" @change="getSubsById()">
                                            <option value="">--Select--</option>
                                            <option v-for="(data, index) in subsList" :key="index" :value="data.id">{{ data.category }}</option>
                                        </select>
                                    </div>

                                    <div class="mb-3">
                                        <label class="form-label">Token</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            class="form-control"
                                            v-model.number="form.token"
                                            placeholder="E.g. 50 DRT"
                                            required
                                            @input="tokenConversionSub"
                                        />
                                        <input
                                            type="hidden"
                                            step="0.01"
                                            class="form-control"
                                            v-model.number="form.price"
                                            placeholder="E.g. 50 DRT"
                                            required
                                        />
                                        </div>

                                    <div class="mb-3">
                                        <label class="form-label">Duration (Days)</label>
                                        <input type="number" class="form-control" v-model="form.duration" readonly/>
                                    </div>

                                    <div class="text-end">
                                        <button @click="createSubscription" v-if="!editSubs" type="submit" class="btn btn-primary mr-2">Save</button> 
                                        <button @click="updateSubscription" v-else-if="editSubs" type="submit" class="btn btn-primary">Update </button>
                                        <button type="button" class="btn btn-secondary me-2" @click="cancel()">Cancel</button>
                                    </div>
                                 
                                </div>
                                </div>
                            </div>
                            </div>

                            <!-- Modal Backdrop -->
                            <div v-if="showModal" class="modal-backdrop fade show"></div>
                        </div>
                        </template>
                    </div>

                    <div v-if="activeTab === 'tour'" class="tab-panel-section tour-section">
                        <div class="card shadow-sm border-0 content-card">
                            <div class="card-header truthdare-header">
                                <div>
                                    <p class="section-kicker mb-1">Travel history</p>
                                    <h5 class="mb-0">Tour History</h5>
                                </div>
                            </div>
                            <div class="card-body p-0 truthdare-shell">
                                <div class="table-responsive">
                                <table class="table table-bordered truthdare-table" style="font-size: 12px;">
                                    <thead>
                                    <tr>
                                        <th scope="col">From</th>
                                        <th scope="col">To</th>
                                        <th scope="col">Travel Date</th>
                                        <th scope="col">Status</th>
                                        <!-- <th scope="col">Action</th> -->
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="escort_tour.length === 0">
                                        <td colspan="4" class="text-center text-muted py-4">No tour records found</td>
                                    </tr>
                                    <tr v-for="(tour, index) in escort_tour" :key="index">
                                        <td>{{ tour.from_city }}</td>
                                        <td>{{ tour.to_city }}</td>
                                        <td>{{ new Date( tour.travel_date ).toDateString() }}</td>
                                        <td>
                                            <span
                                                :class="tour.tour_status == 1 ? 'text-success' : 'text-danger'"
                                            >
                                                {{ tour.tour_status == 1 ? 'Active' : 'Inactive' }}
                                            </span>
                                        </td>

                                        <!-- <td>
                                            <button @click="removeTour(escort_tour)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </td> -->
                                    </tr>
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="activeTab === 'truthdare'" class="tab-panel-section truthdare-section">
                        <div class="card shadow-sm border-0 content-card">
                            <div class="card-header truthdare-header">
                                <div>
                                    <p class="section-kicker mb-1">Client requests</p>
                                    <h5 class="mb-0">Truth & Dare Requests</h5>
                                </div>
                            </div>
                            <div class="card-body p-0 truthdare-shell">
                                <div class="table-responsive">
                                    <table class="table table-hover align-middle mb-0 truthdare-table booking-table" style="font-size: 12px">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Client</th>
                                                <th>Type</th>
                                                <th>Details</th>
                                                <th>Reward</th>
                                                <th>Deadline</th>
                                                <th>Status</th>
                                                <th>Proof</th>
                                                <th class="text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(req, index) in truthDareRequests" :key="req.id">
                                                <td>{{ index + 1 }}</td>
                                                <td><span class="badge badge-info">{{ req.fullname }}</span></td>
                                                <td>
                                                    <span :class="req.request_type === 'truth' ? 'badge bg-info' : 'badge bg-warning'">
                                                        {{ req.request_type }}
                                                    </span>
                                                </td>
                                                <td>{{ req.request_details }}</td>
                                                <td>{{ formatAmount(req.dayruns_token) }}{{ token_label }} </td>
                                                <td>{{ formatDate(req.deadline) }}</td>
                                                <td>
                                                    <span class="truthdare-status" :class="{
                                                        'badge bg-secondary': req.status === 'pending',
                                                        'badge bg-success': req.status === 'accepted',
                                                        'badge bg-danger': req.status === 'cancelled' || req.status === 'expired',
                                                        'badge bg-primary': req.status === 'completed',
                                                        'badge bg-warning': req.status === 'declined'
                                                    }">
                                                        {{ req.status }}
                                                    </span>
                                                </td>
                                                <td class="proof-cell">
                                                     <!-- Show Image -->
                                                    <img 
                                                        v-if="isImagePage(req.proof_media)"
                                                        :src="req.proof_media" 
                                                        alt="Proof Image"
                                                        class="img-fluid rounded"
                                                        style="max-height: 100px; max-width: 100px; object-fit: cover;"
                                                    >

                                                    <!-- Show Video -->
                                                    <video 
                                                        v-else-if="isVideoPage(req.proof_media)"
                                                        :src="req.proof_media"
                                                        controls
                                                        class="rounded"
                                                        style="max-height: 100px; max-width: 100px;"
                                                    >
                                                        Your browser does not support the video tag.
                                                    </video>

                                                </td>
                                                <td class="text-center truthdare-actions">
                                                <button 
                                                    v-if="req.status === 'pending'"
                                                    class="btn btn-success btn-sm me-2 truthdare-action-btn"
                                                    @click="acceptRequest(req)">
                                                    Accept
                                                </button>
                                                
                                                <button 
                                                    v-if="req.status === 'pending'"
                                                    class="btn btn-outline-danger btn-sm truthdare-action-btn"
                                                    @click="declineRequest(req.id)">
                                                    Decline
                                                </button>

                                                <button 
                                                    v-if="req.status === 'accepted'"
                                                    class="btn btn-success btn-sm me-2 truthdare-action-btn"
                                                    @click="openProofModal(req)">
                                                    <i class="fa fa-upload"></i> Upload Proof
                                                </button>

                                                <button 
                                                    v-if="req.status === 'accepted' && req.proof_media"
                                                    class="btn btn-primary btn-sm me-2 truthdare-action-btn"
                                                    @click="openDisputeModal(req)">
                                                    <i class="fa fa-question"></i> Dispute
                                                </button>

                                                </td>

                                            </tr>
                                            <tr v-if="truthDareRequests.length === 0">
                                                <td colspan="9" class="text-center text-muted py-4">
                                                    No Truth & Dare requests found.
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Proof Upload Modal -->
                        <div class="modal fade" id="proofModal" tabindex="-1" aria-hidden="true" ref="proofModal">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header bg-primary text-white">
                                        <h5 class="modal-title">Submit Proof</h5>
                                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="mb-2" style="font-size: 18px; color:#D33E74"><strong>Request:</strong> {{ selectedRequest.request_details }}</p>

                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Set Completion Deadline</label>
                                            <input type="datetime-local" class="form-control" v-model="proofDeadline">
                                        </div>

                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Upload Proof (Image/Video)</label>
                                            <input 
                                                type="file" 
                                                class="form-control"
                                                accept="image/*,video/*"
                                                @change="handleProofUpload"
                                            >
                                            <div class="form-text text-muted">Accepted formats: JPG, PNG, MP4 (Max: 20MB)</div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                        <button class="btn btn-success" @click="submitProof">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dispute Modal -->
                        <div class="modal fade" id="disputeModal" tabindex="-1" aria-hidden="true" ref="disputeModal">
                            <div class="modal-dialog modal-dialog-centered">
                                <div class="modal-content">
                                    <div class="modal-header bg-danger text-white">
                                        <h5 class="modal-title">Raise a Dispute</h5>
                                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                    </div>
                                    <div class="modal-body">
                                        <p class="mb-2" style="font-size: 18px; color:#D33E74">
                                            <strong>Request:</strong> {{ selectedDispute.request_details }}
                                        </p>
                                        <p class="text-muted small mb-3">
                                            Use this form to report a problem with the proof or the outcome of this request.
                                        </p>

                                        <div class="mb-3">
                                            <label class="form-label fw-semibold">Reason for dispute</label>
                                            <textarea
                                                class="form-control"
                                                rows="4"
                                                v-model="disputeReason"
                                                placeholder="Explain why you are disputing this request"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                        <button class="btn btn-danger" @click="submitDispute">Submit Dispute</button>
                                    </div>
                                </div>
                            </div>
                        </div>
            
                    </div>

                     <div v-if="activeTab === 'dispute-tickets'" class="tab-panel-section dispute-tickets-section">
                            <div class="card shadow-sm border-0 content-card">
                                <div class="card-header truthdare-header">
                                    <div>
                                        <p class="section-kicker mb-1">Support records</p>
                                        <h5 class="mb-0">Dispute Tickets</h5>
                                    </div>
                                </div>
                                <div class="card-body p-0 truthdare-shell">
                                    <div class="table-responsive">
                                        <table class="table table-hover align-middle mb-0 truthdare-table booking-table" style="font-size: 12px">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Ticket ID</th>
                                                    <th>Request</th>
                                                    <th>Username</th>
                                                    <th>Description</th>
                                                    <th>Dispute Type</th>
                                                    <th>Status</th>
                                                    <th>Created At</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="ticket in disputeTickets" :key="ticket.id">
                                                    <td>{{ ticket.id }}</td>
                                                    <td>{{ ticket.ticket_id }}</td>
                                                    <td><button @click="viewRequest(ticket.request_id, ticket.dispute_type)" class="btn btn-sm btn-outline-primary">View</button> </td>
                                                    <td>{{ ticket.username }}</td>
                                                    <td>{{ ticket.description }}</td>
                                                    <td>
                                                        <span class="badge bg-info text-dark text-capitalize">
                                                            {{ ticket.dispute_type }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span class="truthdare-status" :class="{
                                                            'badge bg-secondary': ticket.status === 'pending',
                                                            'badge bg-success': ticket.status === 'resolved',
                                                            'badge bg-danger': ticket.status === 'rejected',
                                                            'badge bg-warning': ticket.status === 'open'
                                                        }">
                                                            {{ ticket.status }}
                                                        </span>
                                                    </td>
                                                    <td>{{ new Date(ticket.created_at).toLocaleString() }}</td>
                                                </tr>
                                                <tr v-if="disputeTickets.length === 0">
                                                    <td colspan="8" class="text-center text-muted py-4">
                                                        No dispute tickets found.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                     </div>

                    <div class="modal fade" id="requestDetailsModal" tabindex="-1" aria-hidden="true" ref="requestDetailsModal">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content" style="padding: 20px">
                                <div class="modal-header truthdare-header">
                                    <div>
                                        <p class="section-kicker mb-1">Request info</p>
                                        <h5 class="modal-title mb-0">Request Details</h5>
                                    </div>
                                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                </div>
                                <div class="modal-body truthdare-shell">
                                    <div class="row g-3">

                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Client Name</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.fullname || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Request Type</span>
                                                <span class="detail-value text-capitalize">{{ disputeTicketsDetails.request_type || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="detail-pill">
                                                <span class="detail-label">Request Details</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.request_details || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Reward Amount</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.reward_amount !== undefined && disputeTicketsDetails.reward_amount !== null ? disputeTicketsDetails.reward_amount : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Token</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.dayruns_token !== undefined && disputeTicketsDetails.dayruns_token !== null ? disputeTicketsDetails.dayruns_token : 'N/A' }} {{ token_label }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Currency</span>
                                                <span class="detail-value text-capitalize">{{ disputeTicketsDetails.currency_type || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Status</span>
                                                <span class="detail-value text-capitalize">{{ disputeTicketsDetails.status || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Deadline</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.deadline ? new Date(disputeTicketsDetails.deadline).toLocaleString() : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Created At</span>
                                                <span class="detail-value">{{ disputeTicketsDetails.created_at ? new Date(disputeTicketsDetails.created_at).toLocaleString() : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="disputeTicketsDetails.proof_media">
                                            <div class="detail-pill">
                                                <span class="detail-label">Proof Media</span>
                                                <a :href="disputeTicketsDetails.proof_media" target="_blank" rel="noopener" class="detail-link">
                                                    Open proof media
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade" id="bookingRequestModal" tabindex="-1" aria-hidden="true" ref="bookingRequestModal">
                        <div class="modal-dialog modal-dialog-centered modal-lg">
                            <div class="modal-content" style="padding: 20px">
                                <div class="modal-header truthdare-header">
                                    <div>
                                        <p class="section-kicker mb-1">Booking info</p>
                                        <h5 class="modal-title mb-0">Booking Details</h5>
                                    </div>
                                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                                </div>
                                <div class="modal-body truthdare-shell">
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Model Name</span>
                                                <span class="detail-value">{{ bookingRequestDetails.name || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Escort ID</span>
                                                <span class="detail-value">{{ bookingRequestDetails.escort_id !== undefined && bookingRequestDetails.escort_id !== null ? bookingRequestDetails.escort_id : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Guest ID</span>
                                                <span class="detail-value">{{ bookingRequestDetails.guest_id !== undefined && bookingRequestDetails.guest_id !== null ? bookingRequestDetails.guest_id : 'N/A' }}</span>
                                            </div>
                                        </div> -->
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Status</span>
                                                <span class="detail-value text-capitalize">{{ bookingRequestDetails.status || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Fee Status</span>
                                                <span class="detail-value text-capitalize">{{ bookingRequestDetails.fees_status || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Booked At</span>
                                                <span class="detail-value">{{ bookingRequestDetails.booked_at ? new Date(bookingRequestDetails.booked_at).toLocaleString() : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="detail-pill">
                                                <span class="detail-label">Time</span>
                                                <span class="detail-value">{{ bookingRequestDetails.time || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="detail-pill">
                                                <span class="detail-label">Duration</span>
                                                <span class="detail-value">{{ bookingRequestDetails.duration || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="detail-pill">
                                                <span class="detail-label">Tokens</span>
                                                <span class="detail-value">{{ bookingRequestDetails.dayruns_token !== undefined && bookingRequestDetails.dayruns_token !== null ? bookingRequestDetails.dayruns_token : 'N/A' }} {{ token_label }}</span>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="detail-pill">
                                                <span class="detail-label">Message</span>
                                                <span class="detail-value">{{ bookingRequestDetails.message || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Phone</span>
                                                <span class="detail-value">{{ bookingRequestDetails.phone || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Created At</span>
                                                <span class="detail-value">{{ bookingRequestDetails.created_at ? new Date(bookingRequestDetails.created_at).toLocaleString() : 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Client Name</span>
                                                <span class="detail-value">{{ bookingRequestDetails.fullname || 'N/A' }}</span>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="detail-pill">
                                                <span class="detail-label">Profile Link</span>
                                                <a v-if="bookingRequestDetails.profile_link" :href="bookingRequestDetails.profile_link" target="_blank" rel="noopener" class="detail-link">Open profile</a>
                                                <span v-else class="detail-value">N/A</span>
                                            </div>
                                        </div>
                                        <div class="col-12" v-if="bookingRequestDetails.profilepic">
                                            <div class="detail-pill">
                                                <span class="detail-label">Profile Photo</span>
                                                <a :href="bookingRequestDetails.profilepic" target="_blank" rel="noopener" class="detail-link">
                                                    View profile photo
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
        </div>

        <div class="loader" v-if="pageLoader">
            <span class="dot"></span> 
            <span class="dot"></span>
            <span class="dot"></span>
        </div>

        <v-dialog v-model="showImageDialog" max-width="800px">
        <v-card>
            <v-img :src="selectedImage" aspect-ratio="1.5" contain></v-img>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="pink darken-1" @click="showImageDialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <!-- On Tour Modal -->
        <div id="ontour" class="modal-window">
            <div class="modal-container">
                <div class="modal-top">
                    <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                    <br>
                </div>
                <div class="modal-body">
                    <div >
                    
                        <h2 class="mt-1">
                            ON TOUR
                        </h2>
                        <p class="welcome mb-2">Where are you travelling to?</p>
                        
                        <div >
                            <label class="mb-0">From (State)</label>
                            <v-autocomplete
                            class="login-modal-box"
                            v-model="from"
                            :items="options"
                            label="Select your current location"
                            ></v-autocomplete>
                        </div>
                        <div >
                            <label class="mb-1">To (State) </label>
                            <v-autocomplete
                            class="login-modal-box"
                            v-model="to"
                            :items="options"
                            label="Select your destination"
                            ></v-autocomplete>
                        </div>
                        <div class=" mt-2">
                            <label class="mb-1">To(City)</label>
                            <input type="text"  class="login-modal-box" v-model="to_city" placeholder="e.g Maitama">
                        </div>
                        <div class=" mt-2">
                            <label class="mb-1">Travel Date</label>
                            <input type="date"  class="login-modal-box" v-model="travel_date">
                        </div>

                        <div class=" mt-0">
                            <button class="btn-login" @click="save_tour()" v-if="!tloading"> Save </button>
                            <button class="btn-login" type="button" disabled v-if="tloading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Saving...
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-bottom">
                    <div>
                        <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <input
            type="file"
            ref="storyInput"
            accept="image/*,video/*"
            @change="handleStoryUpload"
            style="display: none"
          />

           <!-- Floating Chat Button -->
           <button
             v-if="escort_data.activation_paid == 1"
              class="floating-chat-btn"
              @click="openChat"
              title="Chat"
            >
              <i class="fa fa-comment"></i>

              <!-- Badge -->
              <span
                v-if="chatHistoryList.length > 0"
                class="chat-badge"
              >
                {{ chatHistoryList.length }}
              </span>
          </button>
    </div>
    </div>
</template>

<script>

import swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';
import * as bootstrap from 'bootstrap'
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile } from '@ffmpeg/util';

const ffmpeg = new FFmpeg();

export default {

    components: {    
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        edit_profile: false,
        btn_success: false,
        btn_success2: false,
        previewLoading: false,
        previewImage:'',
        photo_desc: '',
        photo_price: 0,
        gallery_token: 0,
        video_price: 0,
        video_token: 0,
        is_picture_premium: false,
        showPremiumPopup: false,
        previewVideo:'',
        myprofile: '',
        age: '',
        fullname: '',
        firstname:'',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        from:'',
        to:'',
        travel_date: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading2: false,
        tloading: false,
        cloading: false,
        rloading: false,
        vloading: false,
        userphoto: '',
        country: '',
        profile_pictures:[],
        options: [],
        transport: '',
        activeTab: 'gallery',
        escortHasStory: '',
        tabs: [
            { name: 'gallery', label: 'Gallery' },
            // { name: 'videos', label: 'Videos' },
            { name: 'booking', label: 'Booking' },
            { name: 'rate', label: 'Rates' },
            { name: 'preferences', label: 'About' },
            { name: 'review', label: 'Review' },
            { name: 'follows', label: 'Followers' },
            { name: 'subscriptions', label: 'Subscriptions' },
            { name: 'tour', label: 'Tour History' },
            { name: 'truthdare', label: "Devil's Request" },
            { name: 'dispute-tickets', label: 'Dispute Tickets' },
        ],
        tabs2: [
            { name: 'gallery', label: 'Gallery' },
            // { name: 'videos', label: 'Videos' },
            { name: 'review', label: 'Review' },
            { name: 'follows', label: 'Followers' },
            { name: 'subscriptions', label: 'Subscriptions' },
            { name: 'truthdare', label: "Devil's Request" },
            { name: 'dispute-tickets', label: 'Dispute Tickets' },
        ],
        form: {
        tier_name: "",
        service_type: {
          "Photo Access": "Unlimited",
          "Video Access": "Not available",
          "Stories Access": "Not available"
        },
            price: "",
            token: 0,
            duration: "",
            enabled: "true"
        },
        showModal: false,
        subscriptions: [],
        photos: '',
        profile_photo: '',
        userid: '',
        escort_data: '',
        escort_info:[],
        escort_tour: [],
        escortid: '',
        yearsList: [],

        personality: [],
        interests: [],
        turnOns: [],
        turnOffs: [],
        smokes: '',
        drinks: '',
        tattoosOrPiercings: '',
        groupBooking: '',
        videoChatAvailable: '',
        transportPreference: [],
        build: '',
        bustSize: '',
        ethnicity: '',
        education: '',
        occupations: '',
        weight: '',
        height: '',
        rates: [],
        countLikes: 0,
        countFollowers: 0,
        listFollowers: [],
        profilePictureFile: '',
        profileVideoFile: '',
        escort_video: [],
        services: [],
        video_description: '',
        is_video_premium: '',
        logoutSplash: false,
        logoutMessage: "",
        planId:'',
        features: '',
        monetizedServices: [],
        truthDareRequests: [],
        disputeTickets: [],
        disputeTicketsDetails: [],
        bookingRequestDetails: {},
        selectedRequest: {},
        proofDeadline: '',
        proofFile: null,
        selectedDispute: {},
        disputeReason: '',
        editSubs: false,
        subscriptionId: '',
        isEscort: '',
        genderType: '',
        bookingList: [],
        selectedBooking: null,
        selectedBookingDispute: {},
        bookingDisputeReason: '',
        transactionList: [],
        videoInput: null,
        isImage: false,
        isVideo: false,
        showUploadWarning: false,
        subsList:[],
        subsListId: [],
        min_price: '',
        max_price: '',
        pricingList: [],
        is_boost_status: '',
        to_city: '',
        videoLoaded: '',
        profileCount: 0,
        chatHistoryList: [],
        reviews: [],
        token_label: process.env.VUE_APP_TOKEN_LABEL,
        token_unit: process.env.VUE_APP_TOKEN_UNIT
        };
    },

async beforeMount(){
    this.userid = this.$route.params.escortid;
},

async mounted(){
    await this.listEscortVideos(this.userid)
    await this.listEscortProfile(this.userid)
    await this.getStates()
    await this.listMyProfile(this.userid);
    await this.fetch_preferences();
    await this.fetchServices();
    await this.listMySubscription(this.userid)
    await this.getDisputeTickets(this.userid)
    await this.getSubs();
    await this.getPricing();
    await this.get_chat_history();
    
    
    this.generateYears();

    const now = Date.now();
    const lastShown = localStorage.getItem('lastGalleryWarningTime');

    // 5 minutes = 300,000 milliseconds
    const fiveMinutes = 5 * 60 * 1000;

    if (!lastShown || now - parseInt(lastShown) > fiveMinutes) {
      this.showUploadWarning = true;
      localStorage.setItem('lastGalleryWarningTime', now.toString());
    }
},


methods: {
    copyProfile(profile_link) {
        const url = `${profile_link}`;
        navigator.clipboard.writeText(url);
        alert("Profile link copied!");
    },
    tokenConversion(){
        this.photo_price = Number(this.photo_token) * Number(this.token_unit)
    },
    tokenConversionSub(){
        this.form.price = Number(this.form.token) * Number(this.token_unit)
    },
    tokenConversionRate1(){
        this.rate.in_call_price = Number(this.rate.in_call_dayruns_token) * Number(this.token_unit)
    },
    tokenConversionRate2(){
        this.rate.out_call_price = Number(this.rate.out_call_dayruns_token) * Number(this.token_unit)
    },
    async listReview(userid){
        try{

           const response = await this.$http.get(`/list-reviews/${userid}`, {

            });
             this.reviews = response.data.data                 
            }catch (err) {
                console.log(err);
        }
    },
    async get_chat_history() {
        try {

            const res = await this.$http.get(`/get-chat-history`);

            this.chatHistoryList = res.data.data;
        
        } catch (err) {
            console.error("Chat load error:", err);
        }
    },

    openChat() {
        this.handleChat()
    },

    toSentenceCase(text) {
          if (!text) return '';
          return text
              .toLowerCase()
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
      },

    loadVideo(){
        this.videoLoaded = true;
    },

    unloadVideo(){
        this.videoLoaded = false;
    },

    alertBoost() {
        alert("You must boost your profile before using this feature!");
    },
    closeModal() {
      this.showUploadWarning = false;
    },
    isImagePage(filePath) {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(filePath);
    },
    isVideoPage(filePath) {
        return /\.(mp4|mov|avi|mkv|webm)$/i.test(filePath);
    },

    async getTransactions(escort_id){
        try{
        const response = await this.$http.get(`/fetch-wallet-transactions/${escort_id}`,{} )
        this.transactionList = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getSubs(){
        try{
        const response = await this.$http.get(`/fetch-package`,{} )
        this.subsList = response.data.data;
        }catch (err) {
            console.log(err);
        }
    },

    async getSubsById(){
        try{
        let id = this.form.tier_name
        const response = await this.$http.get(`/fetch-package-byid/${id}`,{} )
        this.subsListId = response.data.data;
        this.form.duration = response.data.data.days;
        this.min_price = response.data.data.min_dayruns_token;
        this.max_price = response.data.data.max_dayruns_token;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getPricing(){
        try{
        const response = await this.$http.get(`/fetch-pricing`,{} )
        this.pricingList = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    validatePrice() {
    if (this.form.price < this.min_price) {
      this.form.price = this.min_price;
    } else if (this.form.price > this.max_price) {
      this.form.price = this.max_price;
    }
  },

    async getBookings(escort_id){
        try{
        const response = await this.$http.get(`/fetch-escort-booking/${escort_id}`,{} )
        this.bookingList = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async toggleAccountType() {
        try{

            const response = await this.$http.get(`/switch-services/${this.userid}/${this.escort_data.account_type}`,{} )
            let success = response.data.success;
            if(success){
                 // Show splash message
                this.logoutMessage = response.data.message;
                this.logoutSplash = true;
                await this.listMyProfile(this.userid);
                // Hide splash after 2.5s
                setTimeout(() => {
                    this.logoutSplash = false;
                    window.location.reload()

                }, 2500);

                
            }
        }catch (err) {
            console.log(err);
        }
    },

    parseServiceType(serviceType) {
    try {
      if (typeof serviceType === "string") {
        return JSON.parse(serviceType);
      }
      return serviceType; // already an object
        } catch (err) {
        console.error("Invalid service_type JSON:", err);
        return {};
        }
    },
    formatDate(date) {
        return date ? new Date(date).toLocaleString() : 'N/A';
    },
    openProofModal(request) {
        this.selectedRequest = request;
        this.proofDeadline = '';
        this.proofFile = null;

        let modal = new bootstrap.Modal(this.$refs.proofModal);
        modal.show();
    },

    openDisputeModal(request) {
        this.selectedDispute = request;
        this.disputeReason = '';

        let modal = new bootstrap.Modal(this.$refs.disputeModal);
        modal.show();
    },

    handleProofUpload(event) {
        this.proofFile = event.target.files[0];
    },

    async acceptRequest(data) {
    try {
        // Ask for confirmation before proceeding
        const confirmAccept = confirm("Are you sure you want to accept this request?");
        if (!confirmAccept) return; // Exit if user cancels

        const response = await this.$http.post('/accept-request', {
            request_id: data.id
            }
         );

        if (response.data.success) {
        // Show splash message
        this.logoutMessage = response.data.message || "Request accepted successfully!";
        this.logoutSplash = true;
        window.location.reload()
        // Hide splash after 2.5s
        setTimeout(() => {
            this.selectedRequest.status = 'accepted';
            bootstrap.Modal.getInstance(this.$refs.proofModal).hide();
            this.logoutSplash = false;
            
        }, 2500);
        } else {
        alert(response.data.message || 'Failed to accept request.');
        }
    } catch (err) {
        console.error('Request acceptance error:', err);
        alert('Something went wrong. Please try again.');
    }
    },

    async submitProof() {
        try {

        if (!this.proofDeadline) {
            alert("Please specify date and time");
            return;
        }

        if (!this.proofFile) {
            alert("Please select proof before submitting.");
            return;
        }

        // make sure proof deadline is not later than dealine
        // Convert to Date objects
        const deadlineDate = new Date(this.selectedRequest.deadline);
        const proofDeadlineDate = new Date(this.proofDeadline);

        // Validate
        if (proofDeadlineDate > deadlineDate) {
        alert("Proof date and time cannot be later than the deadline.");
        return;
        }

        const formData = new FormData();
        formData.append('request_id', this.selectedRequest.id);
        formData.append('proof_datetime', this.proofDeadline);
        formData.append('proof_gallery_video', this.proofFile);

        // Example: send proof to backend
        const response = await this.$http.post('/upload-proof', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            }
        })

        if (response.data.success) {
            // Show splash message
            this.logoutMessage = response.data.message || "Proof uploaded successfully!";
            this.logoutSplash = true;

            // Hide splash after 2.5s
            setTimeout(() => {
                this.selectedRequest.status = 'accepted';
                bootstrap.Modal.getInstance(this.$refs.proofModal).hide();
                this.logoutSplash = false;
                window.location.reload();
            }, 2500);

        } else {
            alert(response.data.message || 'Failed to upload story');
        }
    } catch (err) {
        console.error('Proof upload error:', err);
        alert('Upload failed. Please try again.');
    }
    },

    async submitDispute() {
        try {
            if (!this.disputeReason || !this.disputeReason.trim()) {
                alert("Please enter a reason for the dispute.");
                return;
            }

            const confirmDispute = confirm("Are you sure you want to submit this dispute?");
            if (!confirmDispute) return;

            const response = await this.$http.post('/dispute-request', {
                username: this.escort_data.username,
                user_id: this.userid,
                request_id: this.selectedDispute.id,
                description: this.disputeReason.trim(),
                dispute_type: 'truthdare',
            });

            if (response.data.success) {
                this.logoutMessage = response.data.message || "Dispute submitted successfully!";
                this.logoutSplash = true;

                setTimeout(() => {
                    const modalEl = this.$refs.disputeModal;
                    const modalInstance = bootstrap.Modal.getInstance(modalEl);
                    if (modalInstance) modalInstance.hide();
                    this.logoutSplash = false;
                    window.location.reload();
                }, 2500);
            } else {
                alert(response.data.message || 'Failed to submit dispute.');
            }
        } catch (err) {
            console.error('Dispute submission error:', err);
            alert(err.response?.data?.message || 'Dispute submission failed. Please try again.');
        }
    },

    async declineRequest(id) {
        try{
        
            // Prompt user before deletion
            const confirmDelete = confirm("Are you sure you want to decline this Truth & Dare request?");
            if (!confirmDelete) {
            return; // Exit if user cancels
            }
            const response = await this.$http.get(`/decline-truthdare/${id}`,{} )
            if(response.data.success){
                // Set splash message
                this.logoutMessage = response.data.message || `Request declined!`;
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                window.location.reload()
                this.logoutSplash = false;
                }, 2500); // splash visible for 2.5 seconds
                return;
            }
    
        }catch (err) {
            console.log(err);
        }
    },

    maskPhoneNumber(phone) {
        if (!phone) return '';
        return phone.slice(0, 4) + '*'.repeat(phone.length - 4);
    },

     // Trigger file input
   openStoryUpload() {
    this.$refs.storyInput.click();
   },
    // Handle uploaded file
    async handleStoryUpload(event) {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('escort_id', this.userid);
    formData.append('story_gallery_video', file);

    try {
        const response = await this.$http.post('/upload-story', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
        });

        if (response.data.success) {
        // Show splash message
        this.logoutMessage = response.data.message || "Story uploaded successfully!";
        this.logoutSplash = true;

        // Hide splash after 2.5s
        setTimeout(() => {
            this.logoutSplash = false;
        }, 2500);

        } else {
        alert(response.data.message || 'Failed to upload story');
        }
    } catch (err) {
        console.error('Story upload error:', err);
        alert(err.response ? err.response.data.message : err.message,);
    }
    },

    boost_profile(username) {
        this.$router.push(`/boost-profile/${this.escortid}/${username}`)
    },
    activate_account(username) {
        this.$router.push(`/activate-profile/${this.userid}/${username}`)
    },
    
    generateYears() {
      const start = 1940;
      const end = new Date().getFullYear();
      for (let i = start; i <= end; i++) {
        this.yearsList.push(i);
      }
    },

    backProfile() {
        this.profile = true,
        this.edit_profile = false
    },
    async fetchServices(){
        try{
        const response = await this.$http.get('/fetch-services',{} )
        this.monetizedServices = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getTruthDareRequests(model_id){
        try{
        const response = await this.$http.get(`/fetch-model-truthdare/${model_id}`,{} )
        this.truthDareRequests = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async getDisputeTickets(model_id){
        try{
        const response = await this.$http.get(`/fetch-dispute-tickets/${model_id}`,{} )
        this.disputeTickets = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async viewRequest(request_id, request_type) {
    try{
            const response = await this.$http.get(`/fetch-request-details/${request_id}/${request_type}`,{} )
            const details = Array.isArray(response.data.data)
                ? response.data.data[0]
                : response.data.data;

            this.disputeTicketsDetails = details || {};

            if (request_type === 'truthdare') {
                const modal = new bootstrap.Modal(this.$refs.requestDetailsModal);
                modal.show();
            }
            else if (request_type === 'booking') {
                this.bookingRequestDetails = details || {};
                const modal = new bootstrap.Modal(this.$refs.bookingRequestModal);
                modal.show();
            }

  
    
        }catch (err) {
            console.log(err);
    }
    },

    async createSubscription() {

    const price = parseFloat(this.form.token);

    // ✅ Validate the price range before sending to backend
    if (price < this.min_price || price > this.max_price) {
        alert(`Price must be between ${this.min_price} and ${this.max_price} ${this.token_label}`);
        return; // Stop execution if invalid
    }

      const newSub = {
        escort_id: this.userid,
        tier_name: this.form.tier_name,
        price: parseFloat(this.form.price),
        token: parseFloat(this.form.token),
        duration: parseInt(this.form.duration),
        enabled: this.form.enabled
      };

       await this.$http.post('/create-escort-subscription-plan', newSub)
        .then(response => {
        if (response.data.success) {
            this.listMySubscription(this.userid)
            this.showModal = false;
            //location.reload()
            alert('Services saved successfully');
        } else {
            this.$toast.error(response.data.message || 'Submission failed');
        }
        })
        .catch(error => {
        console.error(error);
        this.$toast.error('Error submitting services');
        });
      this.subscriptions.push(newSub);
      this.showModal = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        tier_name: '',
        service_type: '{"Photo Access": "Unlimited", "Video Access": "Not available", "Stories Access": "Not available"}',
        price: '',
        token: '',
        duration: '',
        enabled: 'true'
      };
    },
    async listMySubscription(escortId){
    try{
        this.pageLoader = true
        const response = await this.$http.get(`/get-escort-subscription-plans-byid/${escortId}`,{} )
        this.subscriptions = response.data.data;
        this.pageLoader = false
    
        }catch (err) {
            console.log(err);
        }
    },

    openEditModal(sub) {
        // let parsedServiceType = {};
        // try {
        //     parsedServiceType = typeof sub.service_type === "string"
        //         ? JSON.parse(sub.service_type)
        //         : sub.service_type;
        // } catch (e) {
        //     console.error("Invalid service_type JSON", e);
        // }

        this.form = {
            subscriptionId: sub.id,
            escort_id: sub.escort_id,
            tier_name: sub.tier_name,
            service_type: {
               
            },
            price: sub.price,
            token: sub.dayruns_token,
            duration: sub.duration,
            enabled: sub.enabled
        };
        this.editSubs = true
        this.showModal = true
    },
    cancel(){
        this.editSubs = false
        this.showModal = false
        this.resetForm()
    },

    async updateSubscription() {
      const newSub = {
        subscriptionId: this.form.subscriptionId,
        escort_id: this.userid,
        tier_name: this.form.tier_name,
        service_type: this.form.service_type,
        price: parseFloat(this.form.price),
        token: this.form.token,
        duration: parseInt(this.form.duration),
        enabled: this.form.enabled
      };

       await this.$http.post('/update-escort-subscription-plan', newSub)
        .then(response => {
        if (response.data.success) {
            this.listMySubscription(this.userid)
            this.showModal = false;
            alert('Services updated successfully');
        } else {
            this.$toast.error(response.data.message || 'Update failed');
        }
        })
        .catch(error => {
        console.error(error);
        this.$toast.error('Error updating services');
        });
      this.subscriptions.push(newSub);
      this.showModal = false;
      this.resetForm();
    },

    async deleteSubscription(id) {
    if (confirm("Are you sure you want to delete this subscription?")) {
       await this.$http.get(`/delete-escort-subscription-plan/${id}`, {})
        .then(response => {
        if (response.data.success) {
            this.listMySubscription(this.userid)
            alert('Services delete successfully');
        } else {
            this.$toast.error(response.data.message || 'delete failed');
        }
        })
        .catch(error => {
        console.error(error);
        this.$toast.error('Error deleting services');
        });
      this.showModal = false;
      this.resetForm();
    }
    },

    handleClick(activate_status){
        if (activate_status === 0) {
        swal.fire({
            title:'Inactive account',
            icon: 'warning',
            width: 450,
            text: 'You have to activate your account to upload gallery',
            });
            return;
        }
        // only open file dialog if activated
        this.$refs.fileInput.click();
    },

    async pickFile() {
    
    const input = this.$refs.fileInput;
    const file = input.files && input.files[0];
    if (!file) return;

    const fileType = file.type;

    // Reset previous preview state
    this.isImage = false;
    this.isVideo = false;
    this.previewImage = null;

    // Check type and preview accordingly
    if (fileType.startsWith("image/")) {
        // Handle image preview
        const reader = new FileReader();
        reader.onload = (e) => {
        this.previewImage = e.target.result; // Show image preview
        this.isImage = true;
        };
        reader.readAsDataURL(file);
    } else if (fileType.startsWith("video/")) {
        // Handle video preview (use object URL for performance)
        this.previewImage = URL.createObjectURL(file);
        this.isVideo = true;
    } else {
        alert("Only image and video files are supported.");
        return;
    }

    // Store file for upload
    this.profilePictureFile = file;

    // Optional: emit event to parent
    this.$emit("input", file);

    // Indicate success (e.g. enable save button)
    this.btn_success = true;
    },


    async pickVideoFile() {
        let input = this.$refs.videoInput;
        let file = input.files;
        
        if (file && file[0]) {

            //this.previewLoading = true; // Start loading

            let reader = new FileReader();
            
            reader.onload = (e) => {
            this.previewVideo = e.target.result; // Show image preview
            this.profileVideoFile = file[0];   // Correct assignment of File object
            };
           
            reader.readAsDataURL(file[0]);

            this.$emit("input", file[0]);  // Optional: for parent components
            
        }
    },

   async compressGalleryFile2(file) {
        if (!ffmpeg.loaded) {
            await ffmpeg.load();
        }

        await ffmpeg.writeFile('input.mp4', await fetchFile(file));

        await ffmpeg.exec([
            '-i', 'input.mp4',
            '-vcodec', 'libx264',
            '-crf', '28',
            '-preset', 'fast',
            'output.mp4'
        ]);

        const data = await ffmpeg.readFile('output.mp4');

        return new File([data.buffer], 'compressed.mp4', {
            type: 'video/mp4',
        });
    },

    async compressGalleryFile(file) {
        if (!file || !file.type || !file.type.startsWith('image/')) {
            return file;
        }

        const compressedFile = await imageCompression(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 1600,
            useWebWorker: true,
        });

        // Preserve original filename
        return new File(
            [compressedFile],
            file.name,
            {
                type: compressedFile.type,
                lastModified: Date.now(),
            }
        );
    },

    async freeUpload() {
        try {
            this.showPremiumPopup = false
            if (!this.photo_desc) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please provide image description',
                });
                return;
            }

            if (this.profilePictureFile.size > 300 * 1024 * 1024) {
                alert("Video too large. Please upload under 300MB");
                return;
            }

            this.loading = true;

            // Build FormData for submission
            const formData = new FormData();
            formData.append('escortid', this.escortid);
            formData.append('photo_desc', this.photo_desc)
            formData.append('photo_price', this.photo_price) 
            formData.append('is_picture_premium', this.is_picture_premium)

            const uploadFile = await this.compressGalleryFile(this.profilePictureFile);

            if (this.profilePictureFile) {
                formData.append('gallery_image', uploadFile);
            }

            // Send request
            const response = await this.$http.post('/upload-galleries', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.data.success) {

                // Set splash message
                this.logoutMessage = response.data.message || "Upload successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
               
                this.listEscortProfile(this.userid)
            } else {
                this.logoutMessage = response.data.message || "Upload not successful!";
                this.logoutSplash = true;

            }
        } catch (err) {
            console.error(err);
            swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: err.response ? err.response.data.message : err.message,
            });
        } finally {
            this.loading = false;
        }
    },
    
    async premiumUpload() {
        try {
            this.showPremiumPopup = false

            if (!this.photo_desc) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please provide gallery description',
                });
                return;
            }
            if (!this.photo_price) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please provide gallery price',
                });
                return;
            }

            if (this.profilePictureFile.size > 300 * 1024 * 1024) {
                alert("Video too large. Please upload under 300MB");
                return;
            }

            // Step 2: Ensure pricing data is loaded
            if (!this.pricingList || this.pricingList.length === 0) {
                await this.getPricing();
            }

            // Step 3: Calculate overall min and max from array
            const allMins = this.pricingList.map(p => parseFloat(p.min_dayruns_token));
            const allMaxs = this.pricingList.map(p => parseFloat(p.max_dayruns_token));

            const globalMin = Math.min(...allMins);
            const globalMax = Math.max(...allMaxs);

            // Step 4: Validate user’s price
            const price = parseFloat(this.photo_token);
            if (price < globalMin || price > globalMax) {
            swal.fire({
                icon: 'warning',
                title: 'Invalid Price',
                text: `Price must be between ${globalMin} and ${globalMax} ${this.token_label}`,
            });
            return;
            }

            this.loading = true;

            // Build FormData for submission
            const formData = new FormData();
            formData.append('escortid', this.escortid);
            formData.append('photo_desc', this.photo_desc)
            formData.append('photo_price', this.photo_price) 
            formData.append('gallery_token', this.photo_token) 
            formData.append('is_picture_premium', true)

            const uploadFile = await this.compressGalleryFile(this.profilePictureFile);

            if (this.profilePictureFile) {
                formData.append('gallery_image', uploadFile);
            }

            // Send request
            const response = await this.$http.post('/upload-galleries', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.data.success) {

                // Set splash message
                this.logoutMessage = response.data.message || "Upload successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
               
                this.listEscortProfile(this.userid)
            } else {
                this.logoutMessage = response.data.message || "Upload not successful!";
                this.logoutSplash = true;

            }
        } catch (err) {
            console.error(err);
            swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: err.response ? err.response.data.message : err.message,
            });
        } finally {
            this.loading = false;
        }
    },

    async uploadVideo() {
        try {

            if (!this.video_description) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please provide video description',
                });
                return;
            }
            if (!this.profileVideoFile) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please select a video',
                });
                return;
            }
            this.vloading = true;

            // Build FormData for submission
            const formData = new FormData();
            formData.append('escortid', this.escortid);
            formData.append('photo_desc', this.video_description);
            formData.append('photo_price', this.video_price);
            formData.append('gallery_token', this.video_token) 
            formData.append('is_picture_premium', this.is_video_premium)

            // Add image file if selected
            if (this.profileVideoFile) {
                formData.append('gallery_image', this.profileVideoFile);
            }

            // Send request
            const response = await this.$http.post('/upload-galleries', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            this.vloading = false;

            if (response.data.success) {
                   // Set splash message
                this.logoutMessage = response.data.message || "Upload successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds

                this.listEscortProfile(this.userid)
            } else {
                this.logoutMessage = response.data.message || "Uplaod not successful!";
                this.logoutSplash = true;
            }
        } catch (err) {
            console.error(err);
            this.loading = false;
            swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: err.response ? err.response.data.message : err.message,
            });
        }
    },
    async listMyProfile(userid){
         try{
            this.pageLoader = true
            const response = await this.$http.post('/list-profile',{ user_id: userid}, {
                headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
            } )
            this.escort_data = response.data.data[0];
            this.isEscort = this.escort_data.account_type
            await localStorage.setItem('email', this.escort_data.email_address);

            if (
                !this.escort_data.age ||
                !this.escort_data.state ||
                !this.escort_data.gender ||
                !this.escort_data.location ||
                !this.escort_data.slogan
            ) {
                this.editProfile(userid);
            }

            if (this.escort_data.account_type === 'escort') {
                await this.listEscortTour(this.escortid)
                await this.getBookings(this.escortid)
                await this.getTransactions(this.escortid)
                await this.fetchRates();
            }
            await this.listReview(this.escortid)

            this.pageLoader = false
        
            }catch (err) {
                console.log(err);
            }
    },
    async listEscortProfile(userid){
         try{

            const response = await this.$http.post('/list-escort-byid',{ user_id: userid} )
            this.escort_info = response.data.data;
            this.escortid = this.escort_info.hid
            this.is_boost_status = response.data.is_boost_status;

            this.getFollowers(this.escortid)
            this.getTruthDareRequests(this.escortid)
            await this.listProfileview(this.escortid)

            }catch (err) {
                console.log(err);
            }
    },
    async listEscortVideos(userid){
        try{
        const response = await this.$http.post('/list-escort-videos',{ user_id: userid} )
        this.escort_video = response.data.data;

        }catch (err) {
            console.log(err);
        }
    },
    async editProfile(userid){
        this.$router.push("/update-profile/"+userid +'/'+this.escort_data.username)
    },

    async addBanks(userid){
        this.$router.push("/add-bank/"+userid +'/'+this.escort_data.username)
    },
    async myWallet(userid){
        this.$router.push("/my-wallet/"+userid +'/'+this.escort_data.username)
    },

    async getStates() {
        try{
        const response = await this.$http.get('/state/fetch', {
            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        })

        response.data.states.forEach((el) => {
        this.options.push({
          value: el.state,
          text: el.state,
        });

      });
               
        }catch (err) {
            console.log(err);
        }
    },
    async remove(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-gallery', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                // Set splash message
                this.logoutMessage = this.response.data.message || "Removed not successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
                return;
            }else{

                this.logoutMessage = this.response.data.message || "Removed successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async removeVideo(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-videos', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                swal.fire({
                    icon: 'error',
                    width:350,
                    height:3,
                    title: this.response.data.message,
                });
                this.listEscortProfile(this.userid)
                return;
            }else{

                   // Set splash message
                this.logoutMessage = this.response.data.message || "Removed successfully!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async save_tour(){
        try {

            this.tloading = true;

            // Send request
            const response = await this.$http.post('/create-tour', {
                escortid: this.escortid,
                from: this.from,
                to: this.to,
                to_city: this.to_city,
                travel_date: this.travel_date,
            });

            this.tloading = false;

            if (response.data.success) {
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                  // Hide the modal
                  document.getElementById("ontour").style.display = "none";
                  window.location.reload()
                }, 2500); // splash visible for 2.5 seconds

                  
            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
            } catch (err) {
                console.error(err);
                this.tloading = false;
                swal.fire({
                icon: 'error',
                title: err.response.data.message,
                text: err.response ? err.response.data.message : err.message,
            });
            }
    },

    async listEscortTour(escortid){
         try{

        const response = await this.$http.post('/list-escort-tours',{ escortid: escortid} )
        this.escort_tour = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async fetch_preferences() {
    try {

        const response = await this.$http.get(`/get-escort-preferences/${this.userid}`);

        if (response.data.success && response.data.data) {
        const prefs = response.data.data[0] ? response.data.data[0] : [];

        this.personality = prefs.personality ? prefs.personality.split(',') : [];
        this.interests = prefs.interests ? prefs.interests.split(',') : [];
        this.turnOns = prefs.turn_ons ? prefs.turn_ons.split(',') : [];
        this.turnOffs = prefs.turn_offs ? prefs.turn_offs.split(',') : [];

        this.smokes = prefs.smokes || '';
        this.drinks = prefs.drinks || '';
        this.tattoosOrPiercings = prefs.tattoos_or_piercings || '';
        this.groupBooking = prefs.group_booking || '';
        this.videoChatAvailable = prefs.video_chat_available || '';
        this.transportPreference = prefs.transport_fare || '';
        this.genderType = prefs.gender_type || '';
        this.build = prefs.build,
        this.bustSize = prefs.bustSize,
        this.ethnicity = prefs.ethnicity,
        this.education= prefs.education,
        this.occupations= prefs.occupations,
        this.weight = prefs.weight,
        this.height=prefs.height
        this.services = prefs.services ? prefs.services.split(',') : [];
        }
    } catch (err) {
        console.error(err);
        // swal.fire({
        // icon: 'error',
        // title: 'Error loading preferences',
        // text: err.response ? err.response.data.message : err.message,
        // });
    }
    },

    async create_preferences() {
    try {

        this.tloading = true;

        const payload = {
            escort_id: this.escortid,
            personality: this.personality,               // array
            interests: this.interests,                   // array
            turnOns: this.turnOns,                       // array
            turnOffs: this.turnOffs,                     // array
            smokes: this.smokes,                         // 'Yes' or 'No'
            drinks: this.drinks,                         // 'Yes' or 'No'
            tattoosOrPiercings: this.tattoosOrPiercings, // 'None', 'Tattoos', 'Piercings', 'Both'
            groupBooking: this.groupBooking,             // 'Yes' or 'No'
            videoChatAvailable: this.videoChatAvailable,  // 'Yes' or 'No'
            transportPreference: this.transportPreference,               // array
            build: this.build,
            bustSize: this.bustSize,
            ethnicity: this.ethnicity,
            education: this.education,
            occupations: this.occupations,
            weight: this.weight,
            height: this.height,
            services: this.services,
            genderType: this.genderType
        };

        const response = await this.$http.post('/create-escort-preferences', payload);

        this.tloading = false;

        if (response.data.success) {
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                window.location.reload(); 
                }, 2500); // splash visible for 2.5 seconds
       
        } else {
        swal.fire({
            icon: 'warning',
            width: 450,
            text: response.data.message,
        });
        }

    } catch (err) {
        console.error(err);
        this.tloading = false;
        swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: err.response ? err.response.data.message : err.message,
        });
      }
    },

    addRate() {
        this.rates.push({ duration: '', in_call_price: '', in_call_dayruns_token: '', out_call_price: '', out_call_dayruns_token: '' });
    },

    async removeRate(index) {
        const rate = this.rates[index];

        // Confirm the rate has been saved (has an ID)
        if (rate.rateid) {
            const confirmDelete = await swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: 'This will permanently delete the rate.',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            });

            if (confirmDelete.isConfirmed) {
            try {
                const response = await this.$http.delete(`/delete-escort-rate/${rate.rateid}`);

                if (response.data.success) {
                this.rates.splice(index, 1); // Remove from UI
                this.logoutMessage = response.data.message || "Successful!";
                this.logoutSplash = true;
                // Wait before redirecting
                setTimeout(() => {
                this.logoutSplash = false;
                }, 2500); // splash visible for 2.5 seconds
                } else {
                swal.fire({
                    icon: 'error',
                    text: response.data.message || 'Failed to delete rate.',
                });
                }
            } catch (err) {
                console.error(err);
                swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
                });
            }
            }
        } else {
            // Not saved in DB yet — just remove locally
            this.rates.splice(index, 1);
        }
    },

    async fetchRates() {
        try {
        const res = await this.$http.get(`/get-escort-rates/${this.userid}`);
        if (res.data.success && res.data.data.length > 0) {
            this.rates = res.data.data;
        } else {
            this.rates = [{ duration: '', inCall: '', outCall: '' }];
        }
        } catch (err) {
        console.error('Failed to fetch rates', err);
        }
    },

    async saveRates() {
        try {
        this.rloading = true;
        const payload = {
            escort_id: this.escortid,
            rates: this.rates,
        };
        const res = await this.$http.post('/create-escort-rates', payload);
        this.rloading = false;

        if (res.data.success) {
            this.logoutMessage = res.data.message || "Successful!";
            this.logoutSplash = true;
            // Wait before redirecting
            setTimeout(() => {
            this.logoutSplash = false;
            window.location.reload(); 
            }, 2500); // splash visible for 2.5 seconds
        } 
        } catch (err) {
        this.loading = false;
        console.error(err);
        swal.fire({ icon: 'error', title: 'Error', text: err.message });
        }
    },

    async handleChat() { 
        this.$router.push(`/chat/${this.escort_info.user_id}/${this.escort_data.username}`)
    },

    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length;
        this.listFollowers = response.data.data;
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },
    async listProfileview(profile_id){
      try{

         const response = await this.$http.get(`/list-profile-view/${profile_id}`, {

          });
           this.profileCount = response.data.data                 
          }catch (err) {
              console.log(err);
      }
},
    async getLikes(userid) {
    try {

        const response = await this.$http.get(`/escort-likes/${userid}`, {});
        this.countLikes = response.data.data.length
        
      
    } catch (err) {
      console.error(err);
     
    }
    },

    formatAmount(value) {
        return new Intl.NumberFormat('en-NG', {
        minimumFractionDigits: 0
        }).format(value);
    },

openActionModal(id) {
    this.selectedBooking = id;
    const modal = new bootstrap.Modal(document.getElementById('actionModal'));
    modal.show();
},

    openTransactionModal(id) {
        this.selectedBooking = id;
        const modal = new bootstrap.Modal(document.getElementById('transactionModal'));
        modal.show();
    },

    openBookingDisputeModal(booking) {
        this.selectedBookingDispute = booking;
        this.bookingDisputeReason = '';

        const modal = new bootstrap.Modal(this.$refs.bookingDisputeModal);
        modal.show();
    },

async action_data(record, action) {
try {
    const response = await this.$http.get(`/action-booking/${record}/${action}`, {

    });

    if (response.data.success) {
    alert(`Booking ${action} successfully!`);

    // Update status locally
    this.bookingList = this.bookingList.map(item => {
        if (item.id === record) {
        return { ...item, status: action };
        }
        return item;
    });

    } else {
    alert(`Failed to ${action} booking.`);
    }
} catch (err) {
    console.error(err);
    alert(`Error occurred while trying to ${action} booking.`);
}
},

async widthdrawFee(amount, truthdare_id) {
    try {
        const response = await this.$http.post("/transfer-wallet", {
            email: this.escort_data.email_address,
            amount: amount,
            user_id: this.userid,
            payment_reference: Date.now(),
            booking_id: truthdare_id
        });

        if (response.data.success) {
            alert(`Transfer of ${amount} successfully!`);
            window.location.reload()

        } else {
        alert(`Failed to transfer ${amount}.`);
        }
    } catch (err) {
        console.error(err);
        alert(`Error occurred while transfering of ${amount}`);
    }
},

    async submitBookingDispute() {
        try {
            if (!this.bookingDisputeReason || !this.bookingDisputeReason.trim()) {
                alert("Please enter a reason for the dispute.");
                return;
            }

            const confirmDispute = confirm("Are you sure you want to submit this dispute?");
            if (!confirmDispute) return;

            const response = await this.$http.post('/dispute-request', {
                username: this.escort_data.username,
                user_id: this.userid,
                request_id: this.selectedBookingDispute.id,
                description: this.bookingDisputeReason.trim(),
                dispute_type: 'booking',
            });

            if (response.data.success) {
                this.logoutMessage = response.data.message || "Dispute submitted successfully!";
                this.logoutSplash = true;

                setTimeout(() => {
                    const modalEl = this.$refs.bookingDisputeModal;
                    const modalInstance = bootstrap.Modal.getInstance(modalEl);
                    if (modalInstance) modalInstance.hide();
                    this.logoutSplash = false;
                    window.location.reload();
                }, 2500);
            } else {
                alert(response.data.message || 'Failed to submit dispute.');
            }
        } catch (err) {
            console.error('Booking dispute submission error:', err);
            alert(err.response?.data?.message || 'Dispute submission failed. Please try again.');
        }
    },

},

}
</script>

<style lang="scss" scoped>
.tooltip-text {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 4px 8px;
  border-radius: 5px;
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  white-space: nowrap;
}

.copy-wrapper:hover .tooltip-text{
  visibility: visible;
}
.form-label{
  font-weight: 600;
}
.chat-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;

  background: #ff3b30;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}

.floating-chat-btn {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #D33E74, #D33E74);
  color: #fff;
  border: none;
  outline: none;
  cursor: pointer;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.floating-chat-btn i {
  font-size: 22px;
}

.floating-chat-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.4);
}
/* Simple modal styles */
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  background: rgba(5, 8, 20, 0.72);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.premium-popup-card {
  width: min(100%, 520px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  background: linear-gradient(180deg, #13111c 0%, #0f1728 100%);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.premium-popup-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  padding: 24px 24px 20px;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.96), rgba(106, 17, 203, 0.92));
  color: #fff;
}

.premium-popup-title-wrap {
  max-width: 88%;
}

.premium-popup-eyebrow {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.premium-popup-title {
  margin-top: 10px;
  color: #fff !important;
  font-size: 1.3rem;
  font-weight: 800;
  line-height: 1.35;
}

.premium-popup-subtitle {
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.95rem;
  line-height: 1.55;
}

.premium-popup-close {
  flex-shrink: 0;
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  transition: transform 0.2s ease, background 0.2s ease;
}

.premium-popup-close:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.2);
}

.premium-popup-body {
  padding: 24px;
}

.premium-info-card {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 18px;
  padding: 16px 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.premium-info-card i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.2), rgba(255, 138, 0, 0.18));
  color: #fff;
  flex-shrink: 0;
}

.premium-info-label {
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.premium-info-value {
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
}

.premium-field-label {
  display: block;
  margin-bottom: 0.55rem;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.9rem;
  font-weight: 700;
}

.premium-input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.75rem;
}

.premium-token-input {
  width: 100%;
  min-height: 50px;
  padding: 0.8rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
  outline: none;
}

.premium-token-input::placeholder {
  color: rgba(255, 255, 255, 0.42);
}

.premium-token-input:focus {
  border-color: rgba(211, 62, 116, 0.5);
  box-shadow: 0 0 0 4px rgba(211, 62, 116, 0.12);
}

.premium-token-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  height: 50px;
  padding: 0 14px;
  border-radius: 14px;
  background: rgba(211, 62, 116, 0.16);
  border: 1px solid rgba(211, 62, 116, 0.24);
  color: #fff;
  font-weight: 700;
  white-space: nowrap;
}

.premium-helper-text {
  color: rgba(255, 255, 255, 0.62);
  font-size: 0.84rem;
  line-height: 1.55;
}

.premium-popup-actions {
  display: grid;
  gap: 10px;
  padding: 0 24px 24px;
}

.premium-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 48px;
  border: 0;
  border-radius: 14px;
  color: #fff;
  font-weight: 700;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.premium-btn:hover {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.premium-btn--primary {
  background: linear-gradient(135deg, #d33e74, #b82f62);
  box-shadow: 0 12px 28px rgba(211, 62, 116, 0.28);
}

.premium-btn--secondary {
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.22);
}

.premium-btn--ghost {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.popup-content {
  max-width: 100%;
}

@media (max-width: 576px) {
  .popup-backdrop {
    padding: 0.75rem;
  }

  .premium-popup-header {
    padding: 18px 18px 16px;
  }

  .premium-popup-body {
    padding: 18px;
  }

  .premium-popup-actions {
    padding: 0 18px 18px;
  }

  .premium-popup-title {
    font-size: 1.1rem;
  }

  .premium-popup-subtitle {
    font-size: 0.9rem;
  }

  .premium-input-wrap {
    flex-direction: column;
    align-items: stretch;
  }

  .premium-token-badge {
    width: 100%;
  }
}

.popup-actions button {
  margin: 5px;
}
.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}
.preview-box {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
}

.preview-video {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  position: absolute;
  z-index: 10;
}
.modal-header{
    background: #D33E74 !important;
    color: #fff;
}
.btn-primary{
    background: #D33E74 !important;
    color: #fff;
    border: 0px;
}
.image-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.account-switch{
    width: 120px;
}
.video-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}
.img-fluid{
    border-radius: 10px;
    width: 100%;
    aspect-ratio: 4 / 5;
    object-fit: cover;
    border-radius: 10px;
    transition: transform 0.3s ease-in-out; /* Optional for smooth effect */
  }
.likes-followers{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
    }
}

@media screen and (max-width: 768px) {
.likes-followers{
    margin-top: -10px;
}
}

.image-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.image-preview:hover {
  border-color: #D33E74;
}

.video-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.video-preview:hover {
  border-color: #D33E74;
}

.upload-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.video-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.file-hidden {
  display: none;
}

.video-hidden {
  display: none;
}

.upload-actions {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}
.photo_desc{
    border: solid 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
    font-family: 'Raleway';
    font-style: normal;
}

.video-actions {
  margin-top: 10px;
}

.rates {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    margin: 20px 0;
}
@media screen and (max-width: 768px) {
    .model-category{
        text-align: center;
    }
    .form-switch{
        text-align: center;
    }
    .rate-row {
        display: flex;
        flex-direction: column;
    }
    .rate-inputs {
        display: flex;
        flex-direction: column;
    }
}
.label-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}
.rate-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.rate-inputs {
  display: flex;
  gap: 10px;
  flex: 1;
}
.input-textx {
  padding: 8px;
  width: 100%;
}
.btn-add, .btn-remove, .btn-user-login {
    margin-top: 10px;
    color: #D33E74;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
}

.label-title{
    font-family: 'Raleway';
    font-weight: bold;
    font-size: 14px;
    color: #fff;
    background: #0A070F;
    border-radius: 10px;
    padding: 0.3rem;
}

.checkbox-group {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.checkbox-group label {
  font-size: 14px;
  color: #D33E74;
}
.btn-user-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 5px;
    background: #D33E74;
    border-radius: 50px;
    color: #fff;
    width: 150px;
    height: 40px;
}
.label {
  display: block;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.bio-tab{
    margin-top: 20px;
}
.profile-tabs {
  gap: 0.65rem;
  padding: 0.5rem;
  border: 1px solid rgba(211, 62, 116, 0.16);
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.01));
  border-bottom: 0;
}

.profile-tabs .nav-item {
  flex: 0 0 auto;
}

.profile-tabs .nav-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.7rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #e5e7eb;
  font-family: 'Raleway';
  font-style: normal;
  font-size: 0.88rem;
  font-weight: 600;
  transition: 0.2s ease;
}

.profile-tabs .nav-link:hover {
  transform: translateY(-1px);
  border-color: rgba(211, 62, 116, 0.35);
  color: #fff;
}

.profile-tabs .nav-link.active {
  background: linear-gradient(135deg, #D33E74, #b82f62);
  color: white;
  border-color: rgba(211, 62, 116, 0.5);
  border-radius: 999px;
  font-family: 'Raleway';
  font-style: normal;
  font-size: 0.88rem;
  box-shadow: 0 12px 24px rgba(211, 62, 116, 0.28);
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }

.profile-tab-content {
    background: linear-gradient(180deg, #111112 0%, #17171b 100%) !important;
    color: #fff !important;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.06) !important;
    border-radius: 18px !important;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);

    div p {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
    }
}

.profile-review-section {
  padding-top: 0.25rem;
}

.profile-review-card {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
}

.profile-review-card .card-body {
  padding: 1rem;
}

.profile-review-card .card-title {
  color: #fff;
  font-size: 0.95rem;
  font-weight: 700;
}

.profile-review-card small {
  color: rgba(255, 255, 255, 0.58) !important;
}

.profile-review-card .card-text {
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.7;
}

.tab-panel-section {
  padding: 0.25rem 0;
}

.tab-panel-section > h5 {
  margin-bottom: 1rem;
  color: #fff;
  font-size: 1.05rem;
  font-weight: 800;
}

.tab-panel-section > h5 strong {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.content-card {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.content-card .card-header {
  background: rgba(255, 255, 255, 0.05) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #fff;
}

.content-card .card-body {
  color: #fff;
}

.content-card .table {
  margin-bottom: 0;
}

.content-card .table thead th {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  border-color: rgba(255, 255, 255, 0.08);
}

.content-card .table td {
  vertical-align: middle;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.08);
}

.content-card .btn,
.content-card button {
  border-radius: 12px;
}

.content-card .modal-content {
  border: 0;
  border-radius: 18px;
}

.content-card .badge {
  border-radius: 999px;
}

.gallery-section .image-upload-wrapper,
.media-section .video-upload-wrapper {
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
}

.gallery-section .photo_desc,
.media-section .photo_desc {
  width: 100%;
  min-height: 46px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.gallery-section .upload-placeholder,
.media-section .video-placeholder {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
}

.gallery-section .image-preview,
.media-section .video-preview {
  border-radius: 18px;
  border: 1px dashed rgba(211, 62, 116, 0.28);
  background: rgba(255, 255, 255, 0.03);
  overflow: hidden;
}

.gallery-section .btn-outline-danger,
.media-section .btn-outline-danger {
  border-color: rgba(211, 62, 116, 0.3);
  color: #D33E74 !important;
}

.booking-section .content-card,
.truthdare-section .content-card {
  margin-bottom: 0;
}

.booking-section .content-card .card-header,
.truthdare-section .content-card .card-header {
  background: linear-gradient(135deg, rgba(211, 62, 116, 0.15), rgba(211, 62, 116, 0.06)) !important;
}

.truthdare-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.1rem;
}

.truthdare-header h5 {
  color: #fff;
  font-size: 1.05rem;
  font-weight: 800;
}

.section-kicker {
  color: #f9a8d4;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.truthdare-shell {
  padding: 0 !important;
}

.truthdare-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  color: #111827;
  border-bottom: 1px solid #dbe3ec;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.truthdare-table tbody tr td {
  color: #000 !important;
  border-color: #e5e7eb;
  background: #fff;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.truthdare-table tbody tr:nth-of-type(even) td {
  background: #f8fafc;
}

.truthdare-table tbody tr:hover td {
  background: #eef4ff;
}

.truthdare-table tbody td,
.truthdare-table tbody td * {
  color: #111827;
}

.booking-section .truthdare-table thead th,
.booking-section .truthdare-table tbody td {
  color: #111827;
}

.truthdare-section .booking-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  color: #111827;
  border-bottom: 1px solid #dbe3ec;
}

.truthdare-section .booking-table tbody td {
  color: #111827 !important;
  background: #fff;
  border-color: #e5e7eb;
}

.truthdare-section .booking-table tbody tr:nth-of-type(even) td {
  background: #f8fafc;
}

.truthdare-section .booking-table tbody tr:hover td {
  background: #eef4ff;
}

.dispute-tickets-section .booking-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  color: #111827;
  border-bottom: 1px solid #dbe3ec;
}

.dispute-tickets-section .booking-table tbody td {
  color: #111827 !important;
  background: #fff;
  border-color: #e5e7eb;
}

.dispute-tickets-section .booking-table tbody tr:nth-of-type(even) td {
  background: #f8fafc;
}

.dispute-tickets-section .booking-table tbody tr:hover td {
  background: #eef4ff;
}

.booking-section .booking-table thead th {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  color: #111827;
  border-bottom: 1px solid #dbe3ec;
}

.booking-section .booking-table tbody td {
  color: #111827 !important;
  background: #fff;
  border-color: #e5e7eb;
}

.booking-section .booking-table tbody tr:nth-of-type(even) td {
  background: #f8fafc;
}

.booking-section .booking-table tbody tr:hover td {
  background: #eef4ff;
}

.booking-section .truthdare-table tbody .text-primary,
.booking-section .truthdare-table tbody .text-success {
  color: #111827 !important;
}

.truthdare-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
  color: #111827 !important;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.proof-cell {
  min-width: 120px;
}

.proof-cell img,
.proof-cell video {
  display: block;
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.truthdare-actions {
  white-space: nowrap;
}

.truthdare-action-btn {
  border-radius: 999px;
  padding-left: 0.85rem;
  padding-right: 0.85rem;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

.detail-pill {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.9rem 1rem;
  border: 1px solid #dbe3ec;
  border-radius: 14px;
  background: #fff;
  min-height: 100%;
}

.detail-label {
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #6b7280;
}

.detail-value {
  font-size: 0.92rem;
  font-weight: 700;
  color: #111827;
  word-break: break-word;
}

.detail-link {
  color: #D33E74;
  font-weight: 700;
  text-decoration: none;
}

.detail-link:hover {
  text-decoration: underline;
}

.rate-section .rates,
.preferences-section .preferences,
.follows-section .followers-section,
.subscriptions-section .table-responsive,
.tour-section .table-responsive {
  padding: 1rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.04);
}

.rate-section .rate-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.85rem;
  margin-bottom: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
}

.rate-section .rate-inputs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.6rem;
  flex: 1;
}

.rate-section .input-textx {
  width: 100%;
  min-width: 0;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.rate-section .btn-add,
.rate-section .btn-user-login {
  border-radius: 12px;
}

.preferences-section .checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0.5rem 0 1rem;
}

.preferences-section .checkbox-group label {
  padding: 0.55rem 0.8rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.preferences-section .label-title {
  display: block;
  margin-top: 1rem;
  margin-bottom: 0.35rem;
  color: #fff;
  font-weight: 700;
}

.follows-section .list-group-item {
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
}

.subscriptions-section .table,
.tour-section .table {
  margin-bottom: 0;
}

.subscriptions-section .table thead th,
.tour-section .table thead th {
  border-color: rgba(255, 255, 255, 0.08);
}

.truthdare-section .content-card .table-light th {
  background: rgba(255, 255, 255, 0.06);
}

.truthdare-section .content-card td {
  color: #000;
}

.table-striped{
    color: #000 !important;
}

.content-card .table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgba(255, 255, 255, 0.025);
  color: #000 !important;
}

@media screen and (max-width: 700px) {
  .profile-tabs {
    gap: 0.45rem;
    padding: 0.4rem;
  }

  .profile-tabs .nav-link {
    padding: 0.6rem 0.85rem;
    font-size: 0.8rem;
  }

  .profile-tab-content {
    padding: 0.85rem !important;
    border-radius: 14px !important;
  }

  .profile-review-card .card-body {
    padding: 0.85rem;
  }

  .tab-panel-section > h5 {
    font-size: 0.98rem;
  }

  .content-card,
  .rate-section .rates,
  .preferences-section .preferences,
  .follows-section .followers-section,
  .subscriptions-section .table-responsive,
  .tour-section .table-responsive {
    border-radius: 14px;
  }

  .rate-section .rate-inputs {
    grid-template-columns: 1fr;
  }

  .preferences-section .checkbox-group {
    gap: 0.4rem;
  }

  .preferences-section .checkbox-group label {
    font-size: 0.82rem;
  }

  .gallery-section .image-upload-wrapper,
  .media-section .video-upload-wrapper {
    padding: 0.85rem;
  }

  .truthdare-header {
    padding: 0.9rem 0.95rem;
  }

  .truthdare-action-btn {
    margin-bottom: 0.35rem;
  }

  .proof-cell img,
  .proof-cell video {
    width: 84px;
    height: 84px;
  }
}

  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 480px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
.modal-container{
    display: flex;
    flex-direction: row;
}

.login-modal-box {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #ccc;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
  }

  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    width: 100%;
    
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}

@media screen and (max-width: 768px) {

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 90%;
      height: 490px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  .modal-container{
    display: flex;
    flex-direction: row;
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: block;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo > img {
    width: 90px;
    text-align: center;
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 20px;

}

.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}

}
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
}
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
        display: flex;
        flex-direction: column;
        justify-content: left;
        margin-top: 30px;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            text-align: left;
            color: #767475;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
            color: #767475;
        }        
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #767475;
        font-family: 'Raleway';
        font-weight: 650;
    
        .btn-trial{
            background: #FFD600;
            border: solid 0;
            color: #000;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-family: 'Raleway';
        font-weight: 650;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
        .btn-boost{
            background: green;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
            color: #ddd;
        }
        .btn-activate{
            background: transparent;
            border: solid 1px;
            font-size: 11px;
            color: #ddd;
            padding: 0.2rem;
            border-radius: 10px;
            animation: blink 1s infinite;

            a{
                color: green;
                text-decoration: none;
            }
        }

        @keyframes blink {
            0% {
                opacity: 1;
                transform: scale(1);
            }

            50% {
                opacity: 0.3;
                transform: scale(1.05);
            }

            100% {
                opacity: 1;
                transform: scale(1);
            }
        }

        .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 70px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        
    }
    @media screen and (max-width: 768px) {
        .bio-buttons{
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
    }
    .horizontal-scroll {
        display: flex;             /* arrange children horizontally */
        gap: 2px;                 /* space between buttons */
        overflow-x: auto;          /* enable horizontal scrolling */
        white-space: nowrap;       /* prevent wrapping to next line */
        padding-bottom: 5px;       /* optional, for scrollbar spacing */
    }

    /* Optional: hide scrollbar for cleaner look */
    .horizontal-scroll::-webkit-scrollbar {
        height: 6px;
    }

    .horizontal-scroll::-webkit-scrollbar-thumb {
        background-color: rgba(0,0,0,0.3);
        border-radius: 3px;
    }

    .horizontal-scroll::-webkit-scrollbar-track {
        background: transparent;
    }

    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
 .profile-picture{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-right: 10px;
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    
    .btn-bank {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 8px;
        width: 80px;
        height: 30px;
        background: #007BFF;
        border: 0.5px solid #007BFF;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        margin: 3px;
    }

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 8px;
        width: 80px;
        height: 30px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        margin: 3px;
    }

    .btn-wallet {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 8px;
        width: 80px;
        height: 30px;
        background: #3aa25d;
        border: 0.5px solid #3aa25d;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
        margin: 3px;
    }
    
    .btn-bank:hover { border: 0.5px solid #FFF;}
    .btn-edit:hover { border: 0.5px solid #FFF;}
    .btn-wallet:hover { border: 0.5px solid #FFF;}
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
 }
 .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        align-items: center;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
           
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        margin-top: 10px;
        margin-bottom: 20px;

        .btn-bank {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            //padding: 10px 18px;
            width: auto;
            height: 30px;
            background: transparent;
            border: 0.5px solid #007BFF;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
            margin: 3px;
        }
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            //padding: 10px 18px;
            width: 80px;
            height: 30px;
            background: transparent;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }

        .btn-wallet {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        //padding: 5px 8px;
        width: 80px;
        height: 30px;
        background: transparent;
        border: 0.5px solid #3aa25d;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        .btn-bank:hover { border: 0.5px solid #FFF;}
        .btn-edit:hover { border: 0.5px solid #FFF;}
        .btn-wallet:hover { border: 0.5px solid #FFF;}
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-size: 12px;
        button{
            box-sizing: border-box;
            width: auto;
            height: 20px;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        .btn-trial{
            background: #FFD600 !important;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            padding: 4px !important;
            border-radius: 10px !important;
            border: solid 0;
            color: #000;
        }
    }

 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>
